/* GENERATED by maths-calculators/build.py, edit calcs.js not this file. */
/* SHLC maths calculators: shared helpers.
   Dual environment: Node (QA/build) and browser (inlined into the template).
   Every helper must be pure and self-contained — run() functions receive this
   object as H and may use nothing else beyond their inputs and Math. */
(function (root) {
  'use strict';

  var H = {};

  /* General number formatting: integers get thousands separators, everything
     else is at most 4 significant figures with trailing zeros trimmed. */
  H.fmt = function (n) {
    if (typeof n !== 'number' || !isFinite(n)) return String(n);
    if (n === 0) return '0';
    /* a real minus sign, not a hyphen: it is the correct maths character and
       it lines up with the minus signs written into the step prose */
    var sign = n < 0 ? '−' : '';
    var a = Math.abs(n);
    if (Number.isInteger(a) && a < 1e15) return sign + a.toLocaleString('en-GB');
    var p = Number(a.toPrecision(4));
    if (Number.isInteger(p) && p < 1e15) return sign + p.toLocaleString('en-GB');
    return sign + String(p);
  };

  /* Money: whole pounds shown without pence, otherwise always 2dp. */
  H.money = function (n) {
    if (typeof n !== 'number' || !isFinite(n)) return String(n);
    var neg = n < 0 ? '−' : '';
    var a = Math.abs(n);
    a = Math.round(a * 100) / 100;
    if (Number.isInteger(a)) return neg + '£' + a.toLocaleString('en-GB');
    return neg + '£' + a.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  /* Fixed decimal places, trailing zeros kept (for method steps like 0.15). */
  H.dp = function (n, places) {
    if (typeof n !== 'number' || !isFinite(n)) return String(n);
    return n.toFixed(places);
  };

  H.gcd = function (a, b) {
    a = Math.abs(Math.round(a)); b = Math.abs(Math.round(b));
    while (b) { var t = b; b = a % b; a = t; }
    return a || 1;
  };

  H.lcm = function (a, b) {
    return Math.abs(Math.round(a) * Math.round(b)) / H.gcd(a, b);
  };

  /* Plural helper for step prose. */
  H.plural = function (n, one, many) {
    return n === 1 ? one : many;
  };

  /* Thousands separators on a number STRING, preserving trailing zeros
     ('12345.680' stays '12,345.680'). For rounded answers where H.fmt's
     zero-trimming would destroy the meaning of the rounding. */
  H.commaStr = function (s) {
    s = String(s);
    var neg = s.charAt(0) === '-' ? '−' : '';
    if (neg) s = s.slice(1);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return neg + parts.join('.');
  };

  /* ---- fractions, shared by the five fraction calculators ----
     A mixed number carries its sign on the whole part: -2 1/2 means
     -(2 + 1/2) = -5/2, never -2 + 1/2. When the whole part is 0 the sign
     lives on the numerator instead. */
  H.toImproper = function (w, n, d) {
    var sign = w < 0 || (w === 0 && n < 0) ? -1 : 1;
    return sign * (Math.abs(w) * Math.abs(d) + Math.abs(n));
  };

  /* Fractions render STACKED (top over bar over bottom), Aadam's rule
     2026-08-19: never a forward slash. Helpers emit the marker ⟦n∕d⟧ and the
     engine turns it into the .mc-fr markup after escaping, so run() stays
     plain text and QA keeps comparing strings. */
  H.frTok = function (n, d) { return '⟦' + n + '∕' + d + '⟧'; };

  /* '−⟦3∕4⟧' style, with a proper minus sign and whole numbers left bare. */
  H.fracStr = function (n, d) {
    if (d === 0) return H.frTok(String(n), '0');
    var neg = (n < 0) !== (d < 0);
    var an = Math.abs(n), ad = Math.abs(d);
    if (ad === 1) return (neg ? '−' : '') + H.fmt(an);
    return (neg ? '−' : '') + H.frTok(H.fmt(an), H.fmt(ad));
  };

  /* Simplest form, as a mixed number when top-heavy: -7/2 → '−3 ⟦1∕2⟧'. */
  H.mixedStr = function (n, d) {
    if (d === 0) return H.fracStr(n, d);
    var neg = (n < 0) !== (d < 0);
    var an = Math.abs(n), ad = Math.abs(d);
    if (ad === 1) return (neg ? '−' : '') + H.fmt(an);
    if (an < ad) return H.fracStr(n, d);
    var w = Math.floor(an / ad), r = an - w * ad;
    if (r === 0) return (neg ? '−' : '') + H.fmt(w);
    return (neg ? '−' : '') + H.fmt(w) + ' ' + H.frTok(H.fmt(r), H.fmt(ad));
  };

  /* --- fraction bar-model drawing, shared by the fraction calculators --- */
  /* the ⟦n∕d⟧ marker as real markup, for widget HTML that bypasses the
     engine's render pass (numbers only, never raw user text) */
  H.frHtml = function (n, d) { return '<span class="mc-fr"><span>' + n + '</span><span>' + d + '</span></span>'; };
  H.mkHtml = function (s) {
    return String(s).replace(/\u27e6([^\u27e6\u27e7\u2215]*)\u2215([^\u27e6\u27e7]*)\u27e7/g,
      '<span class="mc-fr"><span>$1</span><span>$2</span></span>');
  };
  /* one bar of equal cells: the first f1 cells in the first colour, the next
     f2 in the second. */
  H.fbBar = function (x, y, w, cells, f1, f2) {
    var cw = w / cells, out = '', i, cls;
    for (i = 0; i < cells; i++) {
      cls = i < f1 ? ' is-a' : (i < f1 + (f2 || 0) ? ' is-b' : '');
      out += '<rect class="mc-fb-cell' + cls + '" x="' + (x + i * cw).toFixed(1) + '" y="' + y + '" width="' + cw.toFixed(1) + '" height="34"></rect>';
    }
    return out;
  };
  /* a small stacked fraction drawn in SVG, centred on (x, y) */
  H.fbFrac = function (x, y, n, d) {
    return '<text class="mc-fb-fr" x="' + x + '" y="' + (y - 5) + '">' + n + '</text>' +
      '<line class="mc-fb-frbar" x1="' + (x - 11) + '" y1="' + (y + 1) + '" x2="' + (x + 11) + '" y2="' + (y + 1) + '"></line>' +
      '<text class="mc-fb-fr" x="' + x + '" y="' + (y + 16) + '">' + d + '</text>';
  };

  /* Unicode superscript for indices: H.sup(-12) → '⁻¹²'. Keeps answers as
     plain text so QA string comparison and HTML stripping stay honest. */
  H.sup = function (n) {
    var map = { '0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴', '5': '⁵', '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹', '-': '⁻' };
    return String(n).split('').map(function (c) { return map[c] || c; }).join('');
  };

  /* One tappable element of a tap-the-triangle widget: an optional side line
     (with an invisible fat hit line), a pill chip at (cx, cy), and a ? badge.
     The chip's tap means "I know this", the badge's tap means "find this";
     both write their data-set back into the form via the engine. State is
     'known' | 'find' | 'idle'. Shared here because widget() functions are
     serialised via toString and cannot close over anything. */
  H.triEl = function (cx, cy, text, state, setKnow, setFind, ariaKnow, ariaFind, line) {
    var w = 20 + text.length * 7.5;
    var bx = cx + w / 2 + 17;
    /* a falsy setFind means this element can never be the thing to find, so
       it gets no ? badge (e.g. the sine rule calculator only finds a or A) */
    var badge = setFind ? '<g class="mc-tri-badge is-' + state + '" role="button" tabindex="0" data-mc-tap data-set="' + setFind + '" aria-label="' + ariaFind + '">' +
      '<circle class="mc-tri-bhit" cx="' + bx + '" cy="' + cy + '" r="22"></circle>' +
      '<circle cx="' + bx + '" cy="' + cy + '" r="13"></circle>' +
      '<text x="' + bx + '" y="' + cy + '">?</text></g>' : '';
    return '<g class="mc-tri-el is-' + state + '" role="button" tabindex="0" data-mc-tap data-set="' + setKnow + '" aria-label="' + ariaKnow + '">' + (line || '') +
      '<rect class="mc-tri-chip" x="' + (cx - w / 2) + '" y="' + (cy - 15) + '" width="' + w + '" height="30" rx="15"></rect>' +
      '<text class="mc-tri-txt" x="' + cx + '" y="' + cy + '">' + text + '</text></g>' + badge;
  };

  /* The three side lines of the standard widget triangle: right angle bottom
     right, so hyp runs bottom-left to top-right. Keys match the trig naming. */
  H.triLine = function (side) {
    var pts = {
      hyp: ['30', '190', '310', '70'],
      opp: ['310', '190', '310', '70'],
      adj: ['30', '190', '310', '190']
    }[side];
    return '<line class="mc-tri-hit" x1="' + pts[0] + '" y1="' + pts[1] + '" x2="' + pts[2] + '" y2="' + pts[3] + '"></line>' +
      '<line class="mc-tri-line" x1="' + pts[0] + '" y1="' + pts[1] + '" x2="' + pts[2] + '" y2="' + pts[3] + '"></line>';
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = H;
  else root.MC_HELPERS = H;
})(typeof window !== 'undefined' ? window : globalThis);

var MC_CONFIG = {};
MC_CONFIG["percentage-calculator"] = { name: "Percentage Calculator", fields: [{"id": "pct", "label": "Percentage", "suffix": "%", "type": "number", "def": "15"}, {"id": "num", "label": "of the number", "type": "number", "def": "240"}], example: {"pct": 15, "num": 240}, run: (function (v, H) {
      var dec = v.pct / 100;
      var ans = dec * v.num;
      return {
        answer: H.fmt(ans),
        steps: [
          'Write ' + H.fmt(v.pct) + '% as a decimal: ' + H.fmt(v.pct) + ' ÷ 100 = ' + H.fmt(dec),
          'Multiply by ' + H.fmt(v.num) + ': ' + H.fmt(dec) + ' × ' + H.fmt(v.num) + ' = ' + H.fmt(ans)
        ],
        note: 'Quick check: 10% of ' + H.fmt(v.num) + ' is ' + H.fmt(v.num / 10) + '. Does ' + H.fmt(ans) + ' look sensible next to that?'
      };
    }), preview: (function (v, H) { return v.pct + '% of ' + v.num; }) };
MC_CONFIG["percentage-change-calculator"] = { name: "Percentage Change Calculator", fields: [{"id": "oldv", "label": "Original value", "type": "number", "def": "80"}, {"id": "newv", "label": "New value", "type": "number", "def": "100"}], example: {"oldv": 80, "newv": 100}, run: (function (v, H) {
      if (v.oldv === 0) throw new Error('The original value cannot be zero, percentage change compares everything to where you started.');
      var diff = v.newv - v.oldv;
      if (diff === 0) {
        return {
          answer: '0% (no change)',
          steps: [
            'Find the change: ' + H.fmt(v.newv) + ' − ' + H.fmt(v.oldv) + ' = 0',
            'The value has not moved, so the percentage change is 0'
          ]
        };
      }
      var frac = diff / v.oldv;
      var pct = Math.abs(frac) * 100;
      var dir = diff > 0 ? 'increase' : 'decrease';
      var ans = H.fmt(pct) + '% ' + dir;
      return {
        answer: ans,
        steps: [
          'Find the change: ' + H.fmt(v.newv) + ' − ' + H.fmt(v.oldv) + ' = ' + H.fmt(diff),
          'Divide the change by the ORIGINAL value: ' + H.fmt(Math.abs(diff)) + ' ÷ ' + H.fmt(v.oldv) + ' = ' + H.fmt(Math.abs(frac)),
          'Multiply by 100: ' + H.fmt(Math.abs(frac)) + ' × 100 = ' + H.fmt(pct) + ', so the answer is a ' + ans
        ]
      };
    }), preview: (function (v, H) { return 'From ' + v.oldv + ' to ' + v.newv + '. Change = ?'; }) };
MC_CONFIG["reverse-percentage-calculator"] = { name: "Reverse Percentage Calculator", fields: [{"id": "value", "label": "Amount after the change", "type": "number", "def": "360", "gt": 0}, {"id": "pct", "label": "Percentage change", "suffix": "%", "type": "number", "def": "20", "gt": 0}, {"id": "dir", "label": "The change was", "type": "select", "def": "increase", "options": [["increase", "An increase"], ["decrease", "A decrease"]]}], example: {"value": 360, "pct": 20, "dir": "increase"}, run: (function (v, H) {
      if (v.dir === 'decrease' && v.pct >= 100) throw new Error('A decrease of 100% or more leaves nothing to work back from, use a percentage under 100.');
      var base = v.dir === 'increase' ? 100 + v.pct : 100 - v.pct;
      var one = v.value / base;
      var orig = one * 100;
      return {
        answer: H.fmt(orig),
        steps: [
          'After a ' + H.fmt(v.pct) + '% ' + v.dir + ', the amount is ' + (v.dir === 'increase' ? '100% + ' : '100% − ') + H.fmt(v.pct) + '% = ' + H.fmt(base) + '% of the original',
          H.fmt(base) + '% = ' + H.fmt(v.value) + ', so 1% = ' + H.fmt(v.value) + ' ÷ ' + H.fmt(base) + ' = ' + H.fmt(one),
          'The original is 100%: ' + H.fmt(one) + ' × 100 = ' + H.fmt(orig)
        ],
        note: 'Check it forwards: a ' + H.fmt(v.pct) + '% ' + v.dir + ' on ' + H.fmt(orig) + ' takes you back to ' + H.fmt(orig * base / 100) + '.'
      };
    }), preview: (function (v, H) { return v.value + ' after a ' + v.pct + '% ' + v.dir + '. Original = ?'; }) };
MC_CONFIG["what-percentage-calculator"] = { name: "What Percentage Calculator", fields: [{"id": "part", "label": "The part (first number)", "type": "number", "def": "45"}, {"id": "whole", "label": "of the whole (second number)", "type": "number", "def": "60", "gt": 0}], example: {"part": 45, "whole": 60}, run: (function (v, H) {
      var frac = v.part / v.whole;
      var pct = frac * 100;
      return {
        answer: H.fmt(pct) + '%',
        steps: [
          'Write it as a fraction: ' + H.fmt(v.part) + ' out of ' + H.fmt(v.whole) + ' is ' + H.frTok(H.fmt(v.part), H.fmt(v.whole)),
          'Divide: ' + H.fmt(v.part) + ' ÷ ' + H.fmt(v.whole) + ' = ' + H.fmt(frac),
          'Multiply by 100: ' + H.fmt(frac) + ' × 100 = ' + H.fmt(pct) + ', so ' + H.fmt(v.part) + ' is ' + H.fmt(pct) + '% of ' + H.fmt(v.whole)
        ]
      };
    }), preview: (function (v, H) { return v.part + ' out of ' + v.whole + ', as a percentage'; }) };
MC_CONFIG["simple-interest-calculator"] = { name: "Simple Interest Calculator", fields: [{"id": "principal", "label": "Starting amount", "prefix": "\u00a3", "type": "number", "def": "800", "min": 0}, {"id": "rate", "label": "Interest rate per year", "suffix": "%", "type": "number", "def": "5", "min": 0}, {"id": "years", "label": "Time in years", "type": "number", "def": "4", "min": 0}], example: {"principal": 800, "rate": 5, "years": 4}, run: (function (v, H) {
      var oneYear = v.rate / 100 * v.principal;
      var interest = oneYear * v.years;
      var total = v.principal + interest;
      return {
        answer: 'Interest: ' + H.money(interest) + '. Total: ' + H.money(total),
        steps: [
          'Interest for one year: ' + H.fmt(v.rate) + '% of ' + H.money(v.principal) + ' is ' + H.fmt(v.rate / 100) + ' × ' + H.fmt(v.principal) + ' = ' + H.money(oneYear),
          'Multiply by the time: ' + H.money(oneYear) + ' × ' + H.fmt(v.years) + ' ' + H.plural(v.years, 'year', 'years') + ' = ' + H.money(interest),
          'Add it to the starting amount: ' + H.money(v.principal) + ' + ' + H.money(interest) + ' = ' + H.money(total)
        ],
        note: 'Simple interest is always worked out on the original amount. If the interest itself earns interest each year, that is compound interest, a different calculation.'
      };
    }), preview: (function (v, H) { return '£' + v.principal + ' at ' + v.rate + '% a year, for ' + v.years + ' years'; }) };
MC_CONFIG["fraction-calculator"] = { name: "Fraction Calculator", fields: [{"id": "w1", "group": "A", "groupLabel": "First fraction", "slot": "whole", "label": "First whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "a", "group": "A", "slot": "num", "label": "First numerator (top)", "type": "number", "def": "1", "int": true}, {"id": "b", "group": "A", "slot": "den", "label": "First denominator (bottom)", "type": "number", "def": "2", "gt": 0, "int": true}, {"id": "op", "slot": "op", "label": "Operation", "type": "select", "def": "add", "options": [["add", "Add (+)"], ["sub", "Subtract (\u2212)"], ["mul", "Multiply (\u00d7)"], ["div", "Divide (\u00f7)"]]}, {"id": "w2", "group": "B", "groupLabel": "Second fraction", "slot": "whole", "label": "Second whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "c", "group": "B", "slot": "num", "label": "Second numerator (top)", "type": "number", "def": "1", "int": true}, {"id": "d", "group": "B", "slot": "den", "label": "Second denominator (bottom)", "type": "number", "def": "4", "gt": 0, "int": true}], example: {"w1": 0, "a": 1, "b": 2, "op": "add", "w2": 0, "c": 1, "d": 4}, run: (function (v, H) {
      var steps = [];
      var b = Math.abs(v.b), d = Math.abs(v.d);
      var a = H.toImproper(v.w1, v.a, b);
      var c = H.toImproper(v.w2, v.c, d);
      if (v.w1 !== 0) steps.push('Turn the first mixed number into an improper fraction: ' + H.fmt(Math.abs(v.w1)) + ' × ' + H.fmt(b) + ' + ' + H.fmt(Math.abs(v.a)) + ' = ' + H.fmt(Math.abs(a)) + ', so it is ' + H.fracStr(a, b));
      if (v.w2 !== 0) steps.push('Same for the second: ' + H.fmt(Math.abs(v.w2)) + ' × ' + H.fmt(d) + ' + ' + H.fmt(Math.abs(v.c)) + ' = ' + H.fmt(Math.abs(c)) + ', so it is ' + H.fracStr(c, d));
      var n, dd;
      if (v.op === 'add' || v.op === 'sub') {
        var l = H.lcm(b, d), f1 = l / b, f2 = l / d;
        var na = a * f1, nc = c * f2;
        steps.push('Find the lowest common denominator of ' + H.fmt(b) + ' and ' + H.fmt(d) + ': it is ' + H.fmt(l));
        steps.push('Rewrite both over ' + H.fmt(l) + ': ' + H.fracStr(a, b) + ' = ' + H.fracStr(na, l) + ' and ' + H.fracStr(c, d) + ' = ' + H.fracStr(nc, l));
        n = v.op === 'add' ? na + nc : na - nc;
        dd = l;
        steps.push((v.op === 'add' ? 'Add the numerators: ' : 'Subtract the numerators: ') + H.fmt(na) + (v.op === 'add' ? ' + ' : ' − ') + H.fmt(nc) + ' = ' + H.fmt(n) + ', giving ' + H.fracStr(n, dd));
      } else if (v.op === 'mul') {
        n = a * c; dd = b * d;
        steps.push('Multiply the numerators: ' + H.fmt(a) + ' × ' + H.fmt(c) + ' = ' + H.fmt(n));
        steps.push('Multiply the denominators: ' + H.fmt(b) + ' × ' + H.fmt(d) + ' = ' + H.fmt(dd) + ', giving ' + H.fracStr(n, dd));
      } else {
        if (c === 0) throw new Error('You cannot divide by zero, so the second fraction must not be 0.');
        n = a * d; dd = b * c;
        steps.push('Keep the first fraction, flip the second, change ÷ to ×: ' + H.fracStr(a, b) + ' × ' + H.fracStr(d, c));
        steps.push('Multiply across: ' + H.fmt(a) + ' × ' + H.fmt(d) + ' = ' + H.fmt(n) + ' and ' + H.fmt(b) + ' × ' + H.fmt(c) + ' = ' + H.fmt(dd) + ', giving ' + H.fracStr(n, dd));
      }
      if (dd < 0) { n = -n; dd = -dd; }
      var g = H.gcd(n, dd) || 1;
      var sn = n / g, sd = dd / g;
      if (g > 1) steps.push('Simplify: the highest common factor of ' + H.fmt(Math.abs(n)) + ' and ' + H.fmt(dd) + ' is ' + H.fmt(g) + ', so divide top and bottom by it to get ' + H.fracStr(sn, sd));
      var ans = H.mixedStr(sn, sd);
      if (Math.abs(sn) > sd && sd !== 1) steps.push(H.fracStr(sn, sd) + ' is top-heavy: ' + H.fmt(sd) + ' goes into ' + H.fmt(Math.abs(sn)) + ' ' + H.fmt(Math.floor(Math.abs(sn) / sd)) + ' times with ' + H.fmt(Math.abs(sn) % sd) + ' left over, so it is ' + ans);
      else if (g === 1) steps.push(ans + ' is already in its simplest form');
      return { answer: ans, steps: steps };
    }), preview: (function (v, H) { var sym = { add: '+', sub: '−', mul: '×', div: '÷' }[v.op]; var f1 = (Number(v.w1) > 0 ? v.w1 + ' ' : '') + H.frTok(v.a, v.b); var f2 = (Number(v.w2) > 0 ? v.w2 + ' ' : '') + H.frTok(v.c, v.d); return f1 + '  ' + sym + '  ' + f2; }), widget: (function (v, H) {
      var w1 = Number(v.w1), a = Number(v.a), b = Number(v.b), w2 = Number(v.w2), c = Number(v.c), d = Number(v.d);
      var have = isFinite(w1) && isFinite(a) && isFinite(b) && isFinite(w2) && isFinite(c) && isFinite(d) && b > 0 && d > 0;
      if (!have) return '';
      var A = H.toImproper(w1, a, b), C = H.toImproper(w2, c, d);
      var mk = H.mkHtml;
      function fr(n, dd) { return mk(H.fracStr(n, dd)); }
      function line(f, why) {
        return '<p class="mc-rule-line"><span class="mc-rule-f">' + f + '</span><span class="mc-rule-why">' + why + '</span></p>';
      }
      function seqEnd(N, D) {
        var gS = H.gcd(N, D);
        var fin = H.mixedStr(N / gS, D / gS);
        return fin === H.fracStr(N, D) ? '<b>' + fr(N, D) + '</b>' : fr(N, D) + ' = <b>' + mk(fin) + '</b>';
      }
      var ints = Number.isInteger(a) && Number.isInteger(c) && Number.isInteger(b) && Number.isInteger(d);
      var simple = w1 === 0 && w2 === 0 && a >= 0 && c >= 0 && a <= b && c <= d && b <= 12 && d <= 12 && ints;
      var y = 0, rows = '', hint, barLine, i;
      if (v.op === 'add' || v.op === 'sub') {
        var sub = v.op === 'sub';
        var L = b / H.gcd(b, d) * d;
        var n1 = A * (L / b), n2 = C * (L / d);
        var res = sub ? n1 - n2 : n1 + n2;
        var pre = [];
        if (L !== b) pre.push(fr(A, b) + ' = ' + fr(n1, L));
        if (L !== d) pre.push(fr(C, d) + ' = ' + fr(n2, L));
        barLine = line((pre.length ? pre.join(' and ') + ', so ' : '') + fr(n1, L) + (sub ? ' − ' : ' + ') + fr(n2, L) + ' = ' + seqEnd(res, L),
          sub ? 'Match the bottoms, then take the tops away.' : 'Only the bottoms need matching, then the tops add.');
        var drawable = simple && L <= 24 && (a > 0 || c > 0) && (!sub ? true : (res >= 0 && n1 > 0));
        if (!drawable) return barLine;
        function row(label, cells1, f1a, f1b, lbl1, cells2, f2a, f2b, lbl2) {
          var out = '<text class="mc-fb-sub" x="60" y="' + (y + 12) + '">' + label + '</text>';
          out += H.fbBar(60, y + 20, 190, cells1, f1a, f1b) + H.fbFrac(280, y + 36, lbl1[0], lbl1[1]);
          if (cells2) {
            out += '<text class="mc-fb-op" x="316" y="' + (y + 45) + '">' + (sub ? '−' : '+') + '</text>';
            out += H.fbBar(340, y + 20, 190, cells2, f2a, f2b) + H.fbFrac(560, y + 36, lbl2[0], lbl2[1]);
          }
          y += 80;
          return out;
        }
        rows += row('Your fractions', b, a, 0, [a, b], d, 0, c, [c, d]);
        if (b !== d) rows += row('Cut both into ' + H.fmt(L) + 'ths, the common denominator', L, n1, 0, [n1, L], L, 0, n2, [n2, L]);
        if (sub) {
          var out3 = '<text class="mc-fb-sub" x="60" y="' + (y + 12) + '">Cross off ' + H.fmt(n2) + ' ' + H.plural(n2, 'piece', 'pieces') + '</text>';
          out3 += H.fbBar(60, y + 20, 190, L, n1, 0);
          var cw0 = 190 / L;
          for (i = res; i < n1; i++) {
            var xa = 60 + i * cw0 + 3, xb = 60 + (i + 1) * cw0 - 3;
            out3 += '<line class="mc-fb-x" x1="' + xa.toFixed(1) + '" y1="' + (y + 24) + '" x2="' + xb.toFixed(1) + '" y2="' + (y + 50) + '"></line>' +
              '<line class="mc-fb-x" x1="' + xa.toFixed(1) + '" y1="' + (y + 50) + '" x2="' + xb.toFixed(1) + '" y2="' + (y + 24) + '"></line>';
          }
          out3 += H.fbFrac(280, y + 36, res, L);
          y += 80;
          rows += out3;
        } else if (res <= L) {
          rows += row('Together', L, n1, n2, [res, L], 0, 0, 0, null);
        } else {
          var t1 = Math.min(n1, L), o1 = Math.min(L - t1, n2);
          rows += '<text class="mc-fb-sub" x="60" y="' + (y + 12) + '">Together, more than one whole</text>' +
            H.fbBar(60, y + 20, 190, L, t1, o1) + H.fbBar(266, y + 20, 190, L, n1 - t1, n2 - o1) + H.fbFrac(486, y + 36, res, L);
          y += 80;
        }
        hint = sub ? 'Both fractions get cut into the same size pieces, then the second one’s pieces are crossed off.'
          : 'Both fractions get cut into the same size pieces, then the pieces just add up.';
        return '<p class="mc-tri-hint">' + hint + '</p>' +
          '<svg class="mc-tri" viewBox="0 0 600 ' + (y - 14) + '" style="max-width:640px" role="group" aria-label="Bar model">' + rows + '</svg>' + barLine;
      }
      if (v.op === 'mul') {
        var N1 = A * C, D1 = b * d;
        barLine = line(H.fmt(A) + ' × ' + H.fmt(C) + ' = ' + H.fmt(N1) + ' on top, ' + H.fmt(b) + ' × ' + H.fmt(d) + ' = ' + H.fmt(D1) + ' on the bottom: ' + seqEnd(N1, D1),
          'Tops multiply, bottoms multiply, no common denominator needed.');
        if (!(simple && a > 0 && c > 0 && b <= 8 && d <= 8)) return barLine;
        var x0 = 160, y0 = 22, W = 280, Hh = 168;
        var cw = W / b, rh = Hh / d, cells = '', j, cls;
        for (j = 0; j < d; j++) {
          for (i = 0; i < b; i++) {
            cls = i < a && j < c ? ' is-cb' : i < a ? ' is-c1' : j < c ? ' is-c2' : '';
            cells += '<rect class="mc-fb-cell' + cls + '" x="' + (x0 + i * cw).toFixed(1) + '" y="' + (y0 + j * rh).toFixed(1) + '" width="' + cw.toFixed(1) + '" height="' + rh.toFixed(1) + '"></rect>';
          }
        }
        return '<p class="mc-tri-hint">Multiplying fractions is a fraction OF a fraction: one shades the columns, the other shades the rows, and the answer is the dark overlap.</p>' +
          '<svg class="mc-tri" viewBox="0 0 600 244" style="max-width:640px" role="group" aria-label="Overlap grid">' + cells +
          H.fbFrac(x0 + a * cw / 2, y0 + Hh + 26, a, b) + H.fbFrac(x0 + W + 36, y0 + c * rh / 2, c, d) +
          '<text class="mc-fb-sub" x="' + (x0 + W + 62) + '" y="' + (y0 + c * rh / 2 + 5) + '">of the rows</text>' +
          '<text class="mc-fb-sub" x="' + (x0 + a * cw / 2 + 26) + '" y="' + (y0 + Hh + 32) + '">of the columns</text>' +
          '<text class="mc-fb-sub" x="' + x0 + '" y="14">The dark overlap: ' + H.fmt(N1) + ' of the ' + H.fmt(D1) + ' cells</text>' +
          '</svg>' + barLine;
      }
      /* divide */
      if (C === 0) return '';
      var N2 = A * d, D2 = b * C;
      barLine = line(fr(A, b) + ' × ' + fr(d, C) + ' = ' + seqEnd(N2, D2), 'Keep, flip, change: dividing becomes multiplying.');
      var aA = Math.abs(A), aC = Math.abs(C);
      function cardk(x, cls2, tag2, midSvg, sub2) {
        return '<rect class="mc-kfc-card' + cls2 + '" x="' + x + '" y="6" width="150" height="112" rx="14"></rect>' +
          '<text class="mc-kfc-tag" x="' + (x + 75) + '" y="32">' + tag2 + '</text>' + midSvg +
          '<text class="mc-kfc-sub" x="' + (x + 75) + '" y="104">' + sub2 + '</text>';
      }
      var neg1 = A < 0 ? '<text class="mc-kfc-big" x="92" y="72">−</text>' : '';
      var cards = cardk(40, '', 'KEEP', neg1 + H.fbFrac(115, 66, H.fmt(aA), H.fmt(b)), 'the first fraction stays') +
        '<text class="mc-kfc-big" x="215" y="70">→</text>' +
        cardk(235, ' is-2', 'FLIP', H.fbFrac(282, 66, H.fmt(aC), H.fmt(d)) +
          '<text class="mc-kfc-big" x="310" y="72">→</text>' + H.fbFrac(339, 66, H.fmt(d), H.fmt(aC)), 'turn it upside down') +
        '<text class="mc-kfc-big" x="410" y="70">→</text>' +
        cardk(430, ' is-3', 'CHANGE', '<text class="mc-kfc-big" x="505" y="72">÷  →  ×</text>', 'divide becomes times');
      y = 134;
      rows = '';
      var L2 = b / H.gcd(b, d) * d;
      var m1 = a * (L2 / b), m2 = c * (L2 / d);
      var clean = simple && a > 0 && c > 0 && L2 <= 24 && m2 > 0 && m1 % m2 === 0;
      if (clean) {
        var k = m1 / m2;
        rows += '<text class="mc-fb-sub" x="60" y="' + (y + 14) + '">What it means: cut into ' + H.fmt(L2) + 'ths, then count how many groups of ' + H.fmt(m2) + ' fit</text>' +
          H.fbBar(60, y + 22, 300, L2, m1, 0) + H.fbFrac(388, y + 38, H.fmt(m1), H.fmt(L2));
        var cw2 = 300 / L2;
        for (i = 0; i < k; i++) {
          var xs = 60 + i * m2 * cw2 + 3, xe = 60 + (i + 1) * m2 * cw2 - 3;
          rows += '<path class="mc-fb-brk" d="M' + xs.toFixed(1) + ' ' + (y + 62) + 'v8h' + (xe - xs).toFixed(1) + 'v-8"></path>' +
            '<text class="mc-fb-cnt" x="' + ((xs + xe) / 2).toFixed(1) + '" y="' + (y + 90) + '">' + H.fmt(i + 1) + '</text>';
        }
        rows += '<text class="mc-fb-sub" x="60" y="' + (y + 114) + '">It fits exactly ' + H.fmt(k) + ' ' + H.plural(k, 'time', 'times') + ', so the answer is ' + H.fmt(k) + '</text>';
        y += 122;
      }
      return '<p class="mc-tri-hint">Keep, flip, change: three moves and the division becomes a multiplication.' + (clean ? ' The bar below shows what it means: counting how many fit.' : '') + '</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 ' + y + '" style="max-width:640px" role="group" aria-label="Keep flip change">' + cards + rows + '</svg>' + barLine;
    }) };
MC_CONFIG["fraction-to-decimal-calculator"] = { name: "Fraction to Decimal Calculator", fields: [{"id": "mode", "label": "I am starting with a", "type": "select", "def": "fraction", "options": [["fraction", "Fraction"], ["decimal", "Decimal"], ["percentage", "Percentage"]]}, {"id": "fn", "label": "Numerator", "type": "number", "def": "3", "min": 0, "int": true, "group": "F", "groupLabel": "The fraction", "slot": "num", "showIf": {"mode": ["fraction"]}}, {"id": "fd", "label": "Denominator", "type": "number", "def": "8", "gt": 0, "int": true, "group": "F", "slot": "den", "showIf": {"mode": ["fraction"]}}, {"id": "dec", "label": "The decimal", "type": "number", "def": "0.375", "min": 0, "keepRaw": true, "showIf": {"mode": ["decimal"]}}, {"id": "pct", "label": "The percentage", "suffix": "%", "type": "number", "def": "37.5", "min": 0, "keepRaw": true, "showIf": {"mode": ["percentage"]}}], example: {"mode": "fraction", "fn": 3, "fd": 8, "dec": 0.375, "pct": 37.5}, run: (function (v, H) {
      var steps = [];
      function fracBits(numStr) {
        var m = numStr.match(/^(\d+)(?:\.(\d+))?$/);
        if (!m) return null;
        return { int: m[1], frac: m[2] || '' };
      }
      var sn, sd, decDisp, pctDisp;
      if (v.mode === 'fraction') {
        var g0 = H.gcd(v.fn, v.fd);
        sn = v.fn / g0; sd = v.fd / g0;
        if (g0 > 1) steps.push(H.frTok(H.fmt(v.fn), H.fmt(v.fd)) + ' simplifies first: divide top and bottom by ' + H.fmt(g0) + ' to get ' + H.frTok(H.fmt(sn), H.fmt(sd)));
        var t = sd;
        while (t % 2 === 0) t /= 2;
        while (t % 5 === 0) t /= 5;
        var recurring = t !== 1;
        var dec = sn / sd;
        decDisp = H.fmt(dec) + (recurring ? ' (recurring)' : '');
        pctDisp = H.fmt(dec * 100) + '%';
        steps.push(H.frTok(H.fmt(sn), H.fmt(sd)) + ' means ' + H.fmt(sn) + ' ÷ ' + H.fmt(sd) + ' = ' + H.fmt(dec) + (recurring ? ', and the digits repeat for ever (a recurring decimal)' : ''));
        steps.push('Multiply the decimal by 100 for the percentage: ' + H.fmt(dec) + ' × 100 = ' + H.fmt(dec * 100) + '%');
        steps.push('So ' + H.frTok(H.fmt(sn), H.fmt(sd)) + ' = ' + decDisp + ' = ' + pctDisp);
        return { answer: H.frTok(H.fmt(sn), H.fmt(sd)) + ' = ' + decDisp + ' = ' + pctDisp, steps: steps };
      }
      var isDec = v.mode === 'decimal';
      var raw = String(isDec
        ? (v.decRaw !== undefined ? v.decRaw : v.dec)
        : (v.pctRaw !== undefined ? v.pctRaw : v.pct)).trim().replace(/,/g, '').replace(/%$/, '');
      var bits = fracBits(raw);
      if (!bits) throw new Error('That value has something other than digits in it. Check for stray letters or symbols.');
      if (bits.frac.length > 6) throw new Error('Use 6 decimal places or fewer.');
      var k = bits.frac.length;
      var num = Number(bits.int + bits.frac);
      var den = Math.pow(10, k);
      if (isDec) {
        if (k === 0) {
          steps.push(raw + ' is a whole number, so as a fraction it is simply ' + num + '/1');
          sn = num; sd = 1;
        } else {
          steps.push(raw + ' has ' + k + ' decimal ' + H.plural(k, 'place', 'places') + ', so write it over ' + H.fmt(den) + ': ' + H.frTok(num, H.fmt(den)));
          var g1 = H.gcd(num, den);
          sn = num / g1; sd = den / g1;
          if (g1 > 1) steps.push('Simplify: divide top and bottom by ' + H.fmt(g1) + ' to get ' + H.frTok(sn, sd));
          else steps.push(H.frTok(num, H.fmt(den)) + ' is already in its simplest form');
        }
        var pct = Number(raw) * 100;
        pctDisp = H.fmt(pct) + '%';
        steps.push('Multiply by 100 for the percentage: ' + raw + ' × 100 = ' + pctDisp);
        steps.push('So ' + raw + ' = ' + H.frTok(sn, sd) + ' = ' + pctDisp);
        return { answer: raw + ' = ' + H.frTok(sn, sd) + ' = ' + pctDisp, steps: steps };
      }
      steps.push(raw + '% means ' + raw + ' out of 100: ' + raw + '/100');
      var num2 = num, den2 = 100 * den;
      if (k > 0) steps.push('Clear the decimal: multiply top and bottom by ' + H.fmt(den) + ' to get ' + H.frTok(num2, H.fmt(den2)));
      var g2 = H.gcd(num2, den2);
      sn = num2 / g2; sd = den2 / g2;
      if (g2 > 1) steps.push('Simplify: divide top and bottom by ' + H.fmt(g2) + ' to get ' + H.frTok(sn, sd));
      var dec2 = Number(raw) / 100;
      decDisp = H.fmt(dec2);
      steps.push('Divide by 100 for the decimal: ' + raw + ' ÷ 100 = ' + decDisp);
      steps.push('So ' + raw + '% = ' + H.frTok(sn, sd) + ' = ' + decDisp);
      return { answer: raw + '% = ' + H.frTok(sn, sd) + ' = ' + decDisp, steps: steps };
    }), preview: (function (v, H) { var shown = v.mode === 'fraction' ? H.frTok(v.fn, v.fd) : (v.mode === 'decimal' ? String(v.dec) : v.pct + '%'); return shown + ',  as the other two forms'; }), widget: (function (v, H) {
      var mk = H.mkHtml;
      var sn, sd, val;
      if (v.mode === 'fraction') {
        var fn = Number(v.fn), fd = Number(v.fd);
        if (!isFinite(fn) || !isFinite(fd) || fd <= 0 || fn < 0) return '';
        if (fn === 0) { sn = 0; sd = 1; val = 0; }
        else { var g = H.gcd(fn, fd); sn = fn / g; sd = fd / g; val = fn / fd; }
      } else {
        var raw = Number(v.mode === 'decimal' ? v.dec : v.pct);
        if (!isFinite(raw) || raw < 0) return '';
        val = v.mode === 'decimal' ? raw : raw / 100;
        var x = val, den = 1;
        while (den < 100000 && Math.abs(x - Math.round(x)) > 1e-9) { x *= 10; den *= 10; }
        var num = Math.round(x);
        var g2 = H.gcd(num, den);
        sn = num / g2; sd = den / g2;
      }
      var barLine = '<p class="mc-rule-line"><span class="mc-rule-f">' + mk(H.fracStr(sn, sd)) + ' = ' + H.fmt(val) + ' = <b>' + H.fmt(val * 100) + '%</b></span>' +
        '<span class="mc-rule-why">Top ÷ bottom gives the decimal, × 100 gives the percentage.</span></p>';
      var showBar = sn <= sd && sd <= 20 && sd > 1;
      var showLine = val <= 1;
      if (!showBar && !showLine) return barLine;
      var y = 0, rows = '';
      if (showBar) {
        rows += '<text class="mc-fb-sub" x="60" y="12">As shaded pieces</text>' +
          H.fbBar(60, 20, 420, sd, sn, 0) + H.fbFrac(510, 36, H.fmt(sn), H.fmt(sd));
        y = 78;
      }
      if (showLine) {
        var lx = 60, lw = 420, ly = y + 46, i2;
        rows += '<text class="mc-fb-sub" x="60" y="' + (y + 12) + '">On the number line from 0 to 1</text>' +
          '<line x1="' + lx + '" y1="' + ly + '" x2="' + (lx + lw) + '" y2="' + ly + '" stroke="#7C93A4" stroke-width="2"></line>';
        for (i2 = 0; i2 <= 10; i2++) {
          var tx = lx + lw * i2 / 10;
          rows += '<line x1="' + tx + '" y1="' + (ly - (i2 % 5 === 0 ? 7 : 4)) + '" x2="' + tx + '" y2="' + (ly + (i2 % 5 === 0 ? 7 : 4)) + '" stroke="#7C93A4" stroke-width="1.5"></line>';
        }
        rows += '<text class="mc-fb-sub" x="' + lx + '" y="' + (ly + 24) + '" text-anchor="middle">0</text>' +
          '<text class="mc-fb-sub" x="' + (lx + lw / 2) + '" y="' + (ly + 24) + '" text-anchor="middle">0.5</text>' +
          '<text class="mc-fb-sub" x="' + (lx + lw) + '" y="' + (ly + 24) + '" text-anchor="middle">1</text>' +
          '<circle cx="' + (lx + lw * val).toFixed(1) + '" cy="' + ly + '" r="7" fill="#C05621"></circle>' +
          '<text class="mc-fb-cnt" x="' + (lx + lw * val).toFixed(1) + '" y="' + (ly - 16) + '">' + H.fmt(val) + '</text>';
        y = ly + 32;
      }
      return '<p class="mc-tri-hint">One value, three costumes: shaded pieces, a spot on the number line, and a percentage.</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 ' + y + '" style="max-width:640px" role="group" aria-label="Bar and number line">' + rows + '</svg>' + barLine;
    }) };
MC_CONFIG["rounding-calculator"] = { name: "Rounding Calculator", fields: [{"id": "num", "label": "Number to round", "type": "number", "def": "3472.586", "keepRaw": true}, {"id": "mode", "label": "Round to", "type": "select", "def": "10", "options": [["10", "Nearest 10"], ["100", "Nearest 100"], ["1000", "Nearest 1,000"], ["whole", "Nearest whole number"], ["1dp", "1 decimal place"], ["2dp", "2 decimal places"], ["3dp", "3 decimal places"], ["1sf", "1 significant figure"], ["2sf", "2 significant figures"], ["3sf", "3 significant figures"]]}], example: {"num": 3472.586, "mode": "10"}, run: (function (v, H) {
      var raw = String(v.numRaw !== undefined ? v.numRaw : v.num).replace(/,/g, '').trim();
      var neg = raw.charAt(0) === '-' || raw.charAt(0) === '−';
      var absRaw = neg ? raw.slice(1) : raw;
      if (!/^\d*\.?\d*$/.test(absRaw) || absRaw === '' || absRaw === '.') {
        throw new Error('Type the number in full, like 3472.586, no letters or scientific notation.');
      }
      var intPart = (absRaw.split('.')[0] || '0').replace(/^0+(?=\d)/, '');
      var fracPart = absRaw.split('.')[1] || '';
      var absn = Number(absRaw);
      var steps = [], ans;
      var sign = neg ? '−' : '';
      if (absn === 0) {
        return { answer: '0', steps: ['0 rounds to 0 whichever place you round to', 'The answer is 0'] };
      }
      if (v.mode === '10' || v.mode === '100' || v.mode === '1000' || v.mode === 'whole') {
        var m = v.mode === 'whole' ? 1 : Number(v.mode);
        var placeName = { 1: 'units', 10: 'tens', 100: 'hundreds', 1000: 'thousands' }[m];
        var decider;
        if (m === 1) {
          decider = Number(fracPart.charAt(0) || '0');
          steps.push('Rounding to the nearest whole number, look at the first decimal place: the decider digit is ' + decider);
        } else {
          var padded = intPart;
          while (padded.length < 4) padded = '0' + padded;
          decider = Number(padded.charAt(padded.length - String(m).length + 1));
          steps.push('Find the ' + placeName + ' digit, then look one place to its right: the decider digit is ' + decider);
        }
        var down = Math.floor(absn / m) * m;
        var ansAbs = decider >= 5 ? down + m : down;
        ans = sign + H.fmt(ansAbs);
        steps.push(H.commaStr(absRaw) + ' sits between ' + H.fmt(down) + ' and ' + H.fmt(down + m) + ' on the number line');
        steps.push(decider >= 5
          ? 'The decider is 5 or more, so round up: the answer is ' + ans
          : 'The decider is less than 5, so round down: the answer is ' + ans);
        return { answer: ans, steps: steps };
      }
      if (v.mode === '1dp' || v.mode === '2dp' || v.mode === '3dp') {
        var p = Number(v.mode.charAt(0));
        var fracPadded = fracPart;
        while (fracPadded.length < p + 1) fracPadded += '0';
        var kept = intPart + fracPadded.slice(0, p);
        var deciderD = Number(fracPadded.charAt(p));
        var keptShown = intPart + '.' + fracPadded.slice(0, p);
        steps.push('Count ' + p + ' decimal ' + H.plural(p, 'place', 'places') + ' and draw the cut: ' + intPart + '.' + fracPadded.slice(0, p) + ' | ' + (fracPadded.slice(p) || '0'));
        steps.push('The decider digit (the first one after the cut) is ' + deciderD);
        var keptNum = Number(kept);
        if (deciderD >= 5) keptNum += 1;
        var ansStr = String(keptNum);
        while (ansStr.length < p + 1) ansStr = '0' + ansStr;
        var ansOut = ansStr.slice(0, ansStr.length - p) + '.' + ansStr.slice(ansStr.length - p);
        ans = sign + H.commaStr(ansOut);
        steps.push(deciderD >= 5
          ? 'The decider is 5 or more, so the last kept digit rounds up: ' + keptShown + ' becomes ' + ans
          : 'The decider is less than 5, so the kept digits stay as they are: the answer is ' + ans);
        return {
          answer: ans, steps: steps,
          note: 'Keep any trailing zero, it shows the accuracy you rounded to.'
        };
      }
      /* significant figures */
      var k = Number(v.mode.charAt(0));
      var digits = (intPart + fracPart).replace(/^0+/, '');
      if (digits === '') digits = '0';
      var exp;
      if (Number(intPart) > 0) {
        exp = intPart.length;
      } else {
        var lead = 0;
        while (lead < fracPart.length && fracPart.charAt(lead) === '0') lead++;
        exp = -lead;
      }
      var first = digits.charAt(0);
      steps.push('The first significant figure is the first non-zero digit: ' + first);
      var keptS = digits.slice(0, k);
      while (keptS.length < k) keptS += '0';
      var deciderS = Number(digits.charAt(k) || '0');
      steps.push('Keep ' + k + ' ' + H.plural(k, 'figure', 'figures') + ' (' + keptS + '); the decider digit after ' + H.plural(k, 'it', 'them') + ' is ' + deciderS);
      var keptNum2 = Number(keptS);
      if (deciderS >= 5) keptNum2 += 1;
      var keptFinal = String(keptNum2);
      if (keptFinal.length > k) { keptFinal = keptFinal.slice(0, k); exp += 1; }
      var ansOut2;
      if (exp >= k) {
        ansOut2 = keptFinal;
        for (var z = 0; z < exp - k; z++) ansOut2 += '0';
      } else if (exp > 0) {
        ansOut2 = keptFinal.slice(0, exp) + '.' + keptFinal.slice(exp);
      } else {
        ansOut2 = '0.';
        for (var z2 = 0; z2 < -exp; z2++) ansOut2 += '0';
        ansOut2 += keptFinal;
      }
      ans = sign + H.commaStr(ansOut2);
      steps.push(deciderS >= 5
        ? 'The decider is 5 or more, so round the kept figures up and fill to the correct size with zeros: the answer is ' + ans
        : 'The decider is less than 5, so keep the figures and fill to the correct size with zeros: the answer is ' + ans);
      return {
        answer: ans, steps: steps,
        note: 'Zeros that only hold the place (like the zeros in 3,000) are not significant figures, they keep the number the right size.'
      };
    }), preview: (function (v, H) { var m = { '10': 'the nearest 10', '100': 'the nearest 100', '1000': 'the nearest 1,000', whole: 'the nearest whole number', '1dp': '1 decimal place', '2dp': '2 decimal places', '3dp': '3 decimal places', '1sf': '1 significant figure', '2sf': '2 significant figures', '3sf': '3 significant figures' }[v.mode]; return 'Round ' + v.num + ' to ' + m; }) };
MC_CONFIG["hcf-lcm-calculator"] = { name: "HCF and LCM Calculator", fields: [{"id": "a", "label": "First number", "type": "number", "def": "24", "gt": 0, "int": true, "max": 1000000}, {"id": "b", "label": "Second number", "type": "number", "def": "36", "gt": 0, "int": true, "max": 1000000}], example: {"a": 24, "b": 36}, run: (function (v, H) {
      function pf(n) {
        var f = [], p = 2;
        while (p * p <= n) { while (n % p === 0) { f.push(p); n /= p; } p++; }
        if (n > 1) f.push(n);
        return f;
      }
      var steps = [];
      var fa = pf(v.a), fb = pf(v.b);
      steps.push(v.a === 1 ? '1 has no prime factors' : H.fmt(v.a) + ' = ' + fa.join(' × '));
      steps.push(v.b === 1 ? '1 has no prime factors' : H.fmt(v.b) + ' = ' + fb.join(' × '));
      var shared = [], remB = fb.slice(), remA = [];
      for (var i = 0; i < fa.length; i++) {
        var idx = remB.indexOf(fa[i]);
        if (idx > -1) { shared.push(fa[i]); remB.splice(idx, 1); }
        else remA.push(fa[i]);
      }
      var hcf = 1;
      for (var j = 0; j < shared.length; j++) hcf *= shared[j];
      steps.push(shared.length
        ? 'The shared prime factors are ' + shared.join(', ') + ', so HCF = ' + shared.join(' × ') + ' = ' + H.fmt(hcf)
        : 'They share no prime factors, so the HCF is 1');
      var lcm = v.a / hcf * v.b;
      var leftovers = remA.concat(remB);
      steps.push(leftovers.length
        ? 'LCM = HCF × the leftover factors: ' + H.fmt(hcf) + ' × ' + leftovers.join(' × ') + ' = ' + H.fmt(lcm)
        : 'Nothing is left over, the numbers share everything, so the LCM is ' + H.fmt(lcm));
      return {
        answer: 'HCF = ' + H.fmt(hcf) + ', LCM = ' + H.fmt(lcm),
        steps: steps,
        note: 'Check: HCF × LCM always equals the two numbers multiplied together. ' + H.fmt(hcf) + ' × ' + H.fmt(lcm) + ' = ' + H.fmt(hcf * lcm) + ' = ' + H.fmt(v.a) + ' × ' + H.fmt(v.b) + '.'
      };
    }), preview: (function (v, H) { return 'HCF and LCM of ' + v.a + ' and ' + v.b; }) };
MC_CONFIG["prime-factor-calculator"] = { name: "Prime Factor Calculator", fields: [{"id": "n", "label": "Number", "type": "number", "def": "60", "min": 2, "int": true, "max": 10000000}], example: {"n": 60}, run: (function (v, H) {
      var steps = [], ladder = [], factors = [];
      var n = v.n, p = 2;
      while (p * p <= n) {
        while (n % p === 0) { ladder.push(H.fmt(n) + ' ÷ ' + p + ' = ' + H.fmt(n / p)); factors.push(p); n /= p; }
        p++;
      }
      if (n > 1) factors.push(n);
      if (factors.length === 1) {
        steps.push('Try dividing by the primes in order (2, 3, 5, 7, ...): none of them fit');
        steps.push('So ' + H.fmt(v.n) + ' is a prime number, its only prime factor is ' + H.fmt(v.n));
        return { answer: H.fmt(v.n) + ' is a prime number', steps: steps };
      }
      steps.push('Divide by the smallest prime that fits, again and again: ' + ladder.join(', '));
      if (n > 1) steps.push(H.fmt(n) + ' is prime, so the ladder stops there');
      steps.push('Read the primes off the ladder: ' + H.fmt(v.n) + ' = ' + factors.join(' × '));
      var parts = [], i = 0;
      while (i < factors.length) {
        var count = 1;
        while (i + count < factors.length && factors[i + count] === factors[i]) count++;
        parts.push(count > 1 ? factors[i] + H.sup(count) : String(factors[i]));
        i += count;
      }
      var index = parts.join(' × ');
      steps.push('Collect the repeats with powers: ' + H.fmt(v.n) + ' = ' + index);
      return { answer: H.fmt(v.n) + ' = ' + index, steps: steps };
    }), preview: (function (v, H) { return v.n + ' as a product of prime factors'; }) };
MC_CONFIG["standard-form-calculator"] = { name: "Standard Form Calculator", fields: [{"id": "mode", "label": "Convert", "type": "select", "def": "to", "options": [["to", "To standard form"], ["from", "To an ordinary number"]]}, {"id": "ord", "label": "The number", "type": "number", "def": "34500", "min": 0, "keepRaw": true, "showIf": {"mode": ["to"]}}, {"id": "sfa", "label": "Number (1 to 10)", "type": "number", "def": "3.45", "group": "S", "groupLabel": "Standard form", "showIf": {"mode": ["from"]}}, {"id": "sfn", "label": "Power", "type": "number", "def": "4", "int": true, "min": -12, "max": 15, "group": "S", "sep": "\u00d7 10", "cls": "mc-field--power", "showIf": {"mode": ["from"]}}], example: {"mode": "to", "ord": 34500, "sfa": 3.45, "sfn": 4}, run: (function (v, H) {
      var steps = [];
      function shift(digitsStr, pointAfter) {
        var t = digitsStr;
        if (pointAfter <= 0) {
          var out = '0.';
          for (var z = 0; z < -pointAfter; z++) out += '0';
          return out + t;
        }
        while (t.length < pointAfter) t += '0';
        if (t.length === pointAfter) return t;
        return t.slice(0, pointAfter) + '.' + t.slice(pointAfter);
      }
      if (v.mode === 'to') {
        var raw = String(v.ordRaw !== undefined ? v.ordRaw : v.ord).trim().replace(/,/g, '');
        var m = raw.match(/^(\d+)(?:\.(\d+))?$/);
        if (!m) throw new Error('That number has something other than digits in it. Check for stray letters or symbols.');
        if (raw.replace('.', '').length > 17) throw new Error('That number is too long, so use 17 digits or fewer.');
        var intP = m[1].replace(/^0+(?=\d)/, ''), fracP = m[2] || '';
        var digits = (intP + fracP).replace(/^0+/, '');
        if (digits === '') return { answer: '0', steps: ['0 is just 0, and standard form is used for very big and very small numbers', 'The answer is 0'] };
        var exp;
        if (Number(intP) > 0) exp = intP.length;
        else {
          var lead = 0;
          while (lead < fracP.length && fracP.charAt(lead) === '0') lead++;
          exp = -lead;
        }
        var power = exp - 1;
        var aStr = (digits.length > 1 ? digits.charAt(0) + '.' + digits.slice(1) : digits).replace(/\.?0+$/, '');
        steps.push('Put the decimal point after the first non-zero digit: ' + aStr);
        steps.push(power === 0
          ? 'The point has not moved, so the power is 0'
          : 'The point moved ' + Math.abs(power) + ' ' + H.plural(Math.abs(power), 'place', 'places') + ', and the number is ' + (power > 0 ? 'big, so the power is positive' : 'smaller than 1, so the power is negative') + ': 10' + H.sup(power));
        var ansTo = aStr + ' × 10' + H.sup(power);
        steps.push(H.commaStr(raw) + ' = ' + ansTo);
        return { answer: ansTo, steps: steps };
      }
      var aRaw = String(v.sfa), n = v.sfn;
      var aInt = aRaw.split('.')[0].replace('-', '').replace(/^0+(?=\d)/, '');
      var aFrac = aRaw.split('.')[1] || '';
      var aDigits = (aInt + aFrac).replace(/^0+/, '') || '0';
      var pointPos = Number(aInt) > 0 ? aInt.length : (function () {
        var l = 0; while (l < aFrac.length && aFrac.charAt(l) === '0') l++; return -l;
      })();
      var ordinary = shift(aDigits, pointPos + n).replace(/\.$/, '');
      var ansFrom = H.commaStr(ordinary);
      steps.push('The power ' + H.fmt(n) + ' means the decimal point moves ' + Math.abs(n) + ' ' + H.plural(Math.abs(n), 'place', 'places') + ' to the ' + (n >= 0 ? 'right (bigger)' : 'left (smaller)'));
      steps.push(aRaw + ' becomes ' + ansFrom);
      steps.push('So ' + aRaw + ' × 10' + H.sup(n) + ' = ' + ansFrom);
      var out = { answer: ansFrom, steps: steps };
      if (v.sfa < 1 || v.sfa >= 10) {
        out.note = 'Strictly, standard form needs the front number to be at least 1 and less than 10, so ' + aRaw + ' × 10' + H.sup(n) + ' is not in correct standard form, even though it is a perfectly good number.';
      }
      return out;
    }), preview: (function (v, H) {
      if (v.mode === 'to') return v.ord + ' in standard form';
      return v.sfa + ' × 10' + H.sup(v.sfn) + ' as an ordinary number';
    }) };
MC_CONFIG["powers-and-roots-calculator"] = { name: "Powers and Roots Calculator", fields: [{"id": "mode", "label": "What to work out", "type": "select", "def": "power", "options": [["power", "A power, like 3\u2074"], ["sqrt", "A square root, like \u221a20"], ["cbrt", "A cube root, like \u221b27"]]}, {"id": "base", "label": "Number", "type": "number", "def": "3", "min": -1000, "max": 1000}, {"id": "n", "label": "The power", "type": "number", "def": "4", "int": true, "min": -6, "max": 12, "showIf": {"mode": ["power"]}}], example: {"mode": "power", "base": 3, "n": 4}, run: (function (v, H) {
      var steps = [];
      var x = v.base;
      var disp = x < 0 ? '(' + H.fmt(x) + ')' : H.fmt(x);
      if (v.mode === 'power') {
        var n = v.n;
        if (x === 0 && n <= 0) throw new Error('0 to the power 0 (or a negative power) is not defined, try a different base.');
        if (n === 0) {
          steps.push('Anything except 0 raised to the power 0 is 1');
          steps.push('So ' + disp + H.sup(0) + ' = 1');
          return { answer: '1', steps: steps };
        }
        if (n === 1) {
          steps.push('The power 1 leaves a number as it is');
          steps.push('So ' + disp + H.sup(1) + ' = ' + H.fmt(x));
          return { answer: H.fmt(x), steps: steps };
        }
        var absn = Math.abs(n);
        var result = Math.pow(x, absn);
        if (!isFinite(result) || Math.abs(result) > 1e15) throw new Error('That answer is too big to write out in full, try a smaller power or base.');
        if (n < 0) steps.push('A negative power means one over: ' + disp + H.sup(n) + ' = 1 ÷ ' + disp + H.sup(absn));
        if (absn <= 8) {
          var copies = [];
          for (var i = 0; i < absn; i++) copies.push(disp);
          steps.push(disp + H.sup(absn) + ' means ' + absn + ' copies multiplied together: ' + copies.join(' × '));
          if (Number.isInteger(x)) {
            var runningParts = [], acc = x;
            for (var j = 1; j < absn; j++) { runningParts.push(H.fmt(acc) + ' × ' + disp + ' = ' + H.fmt(acc * x)); acc *= x; }
            steps.push('Multiply up: ' + runningParts.join(', '));
          }
        } else {
          steps.push(disp + H.sup(absn) + ' means ' + absn + ' copies of ' + disp + ' multiplied together');
        }
        if (n < 0) {
          if (Number.isInteger(x)) {
            var frac = '1/' + H.fmt(result);
            steps.push(disp + H.sup(absn) + ' = ' + H.fmt(result) + ', so ' + disp + H.sup(n) + ' = ' + frac);
            return { answer: frac, steps: steps, note: 'As a decimal, ' + frac + ' = ' + H.fmt(1 / result) + '.' };
          }
          steps.push('So ' + disp + H.sup(n) + ' = 1 ÷ ' + H.fmt(result) + ' = ' + H.fmt(1 / result));
          return { answer: H.fmt(1 / result), steps: steps };
        }
        steps.push('So ' + disp + H.sup(n) + ' = ' + H.fmt(result));
        return { answer: H.fmt(result), steps: steps };
      }
      if (v.mode === 'sqrt') {
        if (x < 0) throw new Error('You cannot take the square root of a negative number, no number times itself makes a negative.');
        var r = Math.round(Math.sqrt(x));
        if (r * r === x) {
          steps.push('√' + H.fmt(x) + ' asks: which number times itself makes ' + H.fmt(x) + '?');
          steps.push(H.fmt(r) + ' × ' + H.fmt(r) + ' = ' + H.fmt(x) + ', so √' + H.fmt(x) + ' = ' + H.fmt(r));
          return { answer: H.fmt(r), steps: steps };
        }
        var approx = H.fmt(Math.sqrt(x));
        if (Number.isInteger(x)) {
          var s = Math.floor(Math.sqrt(x)), best = 1;
          for (var k = s; k >= 2; k--) { if (x % (k * k) === 0) { best = k; break; } }
          if (best > 1) {
            var inner = x / (best * best);
            steps.push(H.fmt(x) + ' is not a square number, so look for a square factor: ' + H.fmt(x) + ' = ' + H.fmt(best * best) + ' × ' + H.fmt(inner));
            steps.push('√' + H.fmt(x) + ' = √' + H.fmt(best * best) + ' × √' + H.fmt(inner) + ' = ' + H.fmt(best) + '√' + H.fmt(inner));
            steps.push('As a decimal, ' + H.fmt(best) + '√' + H.fmt(inner) + ' ≈ ' + approx);
            return { answer: H.fmt(best) + '√' + H.fmt(inner) + ' (≈ ' + approx + ')', steps: steps };
          }
          steps.push(H.fmt(x) + ' has no square factors, so √' + H.fmt(x) + ' does not simplify, it is already an exact surd');
          steps.push('As a decimal, √' + H.fmt(x) + ' ≈ ' + approx);
          return { answer: '√' + H.fmt(x) + ' (≈ ' + approx + ')', steps: steps };
        }
        steps.push('√' + H.fmt(x) + ' is not a whole number');
        steps.push('√' + H.fmt(x) + ' ≈ ' + approx);
        return { answer: approx, steps: steps };
      }
      /* cube root */
      var rc = Math.round(Math.cbrt(x));
      if (rc * rc * rc === x) {
        steps.push('∛' + H.fmt(x) + ' asks: which number, used three times in a multiplication, makes ' + H.fmt(x) + '?');
        steps.push(H.fmt(rc) + ' × ' + H.fmt(rc) + ' × ' + H.fmt(rc) + ' = ' + H.fmt(x) + ', so ∛' + H.fmt(x) + ' = ' + H.fmt(rc));
        return { answer: H.fmt(rc), steps: steps, note: x < 0 ? 'Cube roots of negative numbers are fine, a negative times a negative times a negative is negative.' : undefined };
      }
      var approxC = H.fmt(Math.cbrt(x));
      steps.push(H.fmt(x) + ' is not a perfect cube, so the exact answer stays as the root ∛' + H.fmt(x));
      steps.push('As a decimal, ∛' + H.fmt(x) + ' ≈ ' + approxC);
      return { answer: '∛' + H.fmt(x) + ' (≈ ' + approxC + ')', steps: steps };
    }), preview: (function (v, H) { if (v.mode === 'sqrt') return '√' + v.base; if (v.mode === 'cbrt') return '∛' + v.base; return v.base + H.sup(v.n); }) };
MC_CONFIG["ratio-calculator"] = { name: "Ratio Calculator", fields: [{"id": "a", "group": "R", "groupLabel": "The ratio", "label": "First part", "type": "number", "def": "12", "gt": 0, "int": true}, {"id": "b", "group": "R", "label": "Second part", "type": "number", "def": "18", "gt": 0, "int": true}, {"id": "c", "group": "R", "label": "Third part (0 if none)", "type": "number", "def": "0", "min": 0, "int": true}], example: {"a": 12, "b": 18, "c": 0}, run: (function (v, H) {
      var parts = [v.a, v.b];
      if (v.c > 0) parts.push(v.c);
      var g = parts[0];
      for (var i = 1; i < parts.length; i++) g = H.gcd(g, parts[i]);
      var out = [];
      for (var j = 0; j < parts.length; j++) out.push(parts[j] / g);
      var steps = [];
      var joinedIn = parts.join(' : ');
      var joinedOut = out.join(' : ');
      if (g > 1) {
        steps.push('Find the highest common factor of ' + parts.join(', ') + ': it is ' + g);
        var divs = [];
        for (var k = 0; k < parts.length; k++) divs.push(parts[k] + ' ÷ ' + g);
        steps.push('Divide every part by ' + g + ': ' + divs.join(' : '));
        steps.push('So ' + joinedIn + ' = ' + joinedOut);
      } else {
        steps.push('Look for a number that divides every part: the highest common factor of ' + parts.join(', ') + ' is 1');
        steps.push('Nothing bigger than 1 divides every part, so ' + joinedIn + ' is already in its simplest form: ' + joinedOut);
      }
      var res = { answer: joinedOut, steps: steps };
      if (parts.length === 2 && out[0] !== 1) {
        res.note = 'In the form 1 : n, divide both parts by ' + out[0] + ': 1 : ' + H.fmt(out[1] / out[0]) + '.';
      }
      return res;
    }), preview: (function (v, H) { return 'Simplify ' + v.a + ' : ' + v.b + (Number(v.c) > 0 ? ' : ' + v.c : ''); }) };
MC_CONFIG["ratio-sharing-calculator"] = { name: "Ratio Sharing Calculator", fields: [{"id": "mode", "label": "What to do", "type": "select", "def": "share", "options": [["share", "Share an amount in a ratio"], ["missing", "Missing value: a : b = c : ?"]]}, {"id": "amount", "label": "Amount to share", "type": "number", "def": "60", "min": 0, "showIf": {"mode": ["share"]}}, {"id": "a", "group": "R", "groupLabel": "The ratio", "label": "Ratio, first part (a)", "type": "number", "def": "2", "gt": 0}, {"id": "b", "group": "R", "label": "Ratio, second part (b)", "type": "number", "def": "3", "gt": 0}, {"id": "c", "group": "R", "label": "Third ratio part (0 if none)", "type": "number", "def": "0", "min": 0, "showIf": {"mode": ["share"]}}, {"id": "k", "label": "The known value c", "type": "number", "def": "12", "min": 0, "hint": "Lines up with the first part a; the ? sits opposite b.", "showIf": {"mode": ["missing"]}}], example: {"mode": "share", "amount": 60, "a": 2, "b": 3, "c": 0, "k": 0}, run: (function (v, H) {
      var steps = [];
      if (v.mode === 'missing') {
        if (v.k <= 0) throw new Error('Enter the known value c (greater than 0) for the missing value mode.');
        var sf = v.k / v.a;
        var missing = v.b * sf;
        steps.push('The left parts go from ' + H.fmt(v.a) + ' to ' + H.fmt(v.k) + ': the scale factor is ' + H.fmt(v.k) + ' ÷ ' + H.fmt(v.a) + ' = ' + H.fmt(sf));
        steps.push('Multiply the other part by the same scale factor: ' + H.fmt(v.b) + ' × ' + H.fmt(sf) + ' = ' + H.fmt(missing));
        steps.push('So ' + H.fmt(v.a) + ' : ' + H.fmt(v.b) + ' = ' + H.fmt(v.k) + ' : ' + H.fmt(missing));
        return { answer: H.fmt(missing), steps: steps };
      }
      if (v.amount <= 0) throw new Error('Enter an amount to share greater than 0.');
      var parts = [v.a, v.b];
      if (v.c > 0) parts.push(v.c);
      var total = 0;
      for (var i = 0; i < parts.length; i++) total += parts[i];
      var one = v.amount / total;
      var exact = Math.abs(one * 100 - Math.round(one * 100)) < 1e-9;
      steps.push('Add the ratio parts: ' + parts.join(' + ') + ' = ' + H.fmt(total) + ' parts in total');
      steps.push('One part = ' + H.fmt(v.amount) + ' ÷ ' + H.fmt(total) + ' = ' + H.fmt(one));
      var shares = [], works = [];
      for (var j = 0; j < parts.length; j++) {
        shares.push(H.fmt(parts[j] * one));
        works.push(H.fmt(parts[j]) + ' × ' + H.fmt(one) + ' = ' + H.fmt(parts[j] * one));
      }
      var joined = shares.length === 3 ? shares[0] + ', ' + shares[1] + ' and ' + shares[2] : shares.join(' and ');
      steps.push('Work out each share: ' + works.join('; ') + ', the shares are ' + joined);
      var sum = 0;
      for (var s = 0; s < parts.length; s++) sum += parts[s] * one;
      var res = {
        answer: joined,
        steps: steps,
        note: 'Check: the shares add back to ' + H.fmt(sum) + (exact ? ', the full amount.' : ', the amount does not divide evenly into ' + H.fmt(total) + ' parts, so the shares are shown to 4 significant figures.')
      };
      return res;
    }), preview: (function (v, H) { if (v.mode === 'missing') return v.a + ' : ' + v.b + '  =  ' + v.k + ' : ?'; return 'Share ' + v.amount + ' in the ratio ' + v.a + ' : ' + v.b + (Number(v.c) > 0 ? ' : ' + v.c : ''); }) };
MC_CONFIG["scale-calculator"] = { name: "Scale Calculator", fields: [{"id": "mode", "label": "What to find", "type": "select", "def": "maptoreal", "options": [["maptoreal", "Map to real distance"], ["realtomap", "Real to map distance"], ["findscale", "Find the scale"]]}, {"id": "n", "label": "Scale: 1 to n", "type": "number", "def": "25000", "gt": 0, "showIf": {"mode": ["maptoreal", "realtomap"]}}, {"id": "mapcm", "label": "Map or model measurement (cm)", "type": "number", "def": "4", "gt": 0, "showIf": {"mode": ["maptoreal", "findscale"]}}, {"id": "real", "label": "Real distance", "type": "number", "def": "3", "min": 0, "showIf": {"mode": ["realtomap", "findscale"]}}, {"id": "realUnit", "label": "Real distance unit", "type": "select", "def": "km", "options": [["km", "Kilometres (km)"], ["m", "Metres (m)"], ["cm", "Centimetres (cm)"]], "showIf": {"mode": ["realtomap", "findscale"]}}], example: {"mode": "maptoreal", "n": 25000, "mapcm": 4, "real": 0, "realUnit": "km"}, run: (function (v, H) {
      var steps = [];
      var unitCm = { km: 100000, m: 100, cm: 1 };
      function best(cm) {
        if (cm >= 100000) return H.fmt(cm / 100000) + ' km';
        if (cm >= 100) return H.fmt(cm / 100) + ' m';
        return H.fmt(cm) + ' cm';
      }
      if (v.mode === 'maptoreal') {
        var realCm = v.mapcm * v.n;
        steps.push('A scale of 1 : ' + H.fmt(v.n) + ' means every 1 cm on the map is ' + H.fmt(v.n) + ' cm in real life');
        steps.push('Multiply: ' + H.fmt(v.mapcm) + ' cm × ' + H.fmt(v.n) + ' = ' + H.fmt(realCm) + ' cm');
        var ansB = best(realCm);
        if (realCm >= 100000) steps.push('Convert: ' + H.fmt(realCm) + ' ÷ 100 = ' + H.fmt(realCm / 100) + ' m, and ÷ 1,000 again = ' + ansB);
        else if (realCm >= 100) steps.push('Convert: ' + H.fmt(realCm) + ' cm ÷ 100 = ' + ansB);
        else steps.push('That stays comfortable in centimetres: ' + ansB);
        return { answer: ansB, steps: steps };
      }
      if (v.mode === 'realtomap') {
        if (v.real <= 0) throw new Error('Enter the real distance (greater than 0).');
        var rc = v.real * unitCm[v.realUnit];
        steps.push('Convert the real distance to centimetres: ' + H.fmt(v.real) + ' ' + v.realUnit + ' = ' + H.fmt(rc) + ' cm');
        var mapAns = rc / v.n;
        steps.push('Divide by the scale: ' + H.fmt(rc) + ' ÷ ' + H.fmt(v.n) + ' = ' + H.fmt(mapAns) + ' cm');
        steps.push('So the map measurement is ' + H.fmt(mapAns) + ' cm');
        return { answer: H.fmt(mapAns) + ' cm', steps: steps };
      }
      if (v.real <= 0) throw new Error('Enter the real distance (greater than 0) to find the scale.');
      var rc2 = v.real * unitCm[v.realUnit];
      steps.push('Convert the real distance to centimetres: ' + H.fmt(v.real) + ' ' + v.realUnit + ' = ' + H.fmt(rc2) + ' cm');
      var nf = rc2 / v.mapcm;
      steps.push('Divide the real distance by the map distance: ' + H.fmt(rc2) + ' ÷ ' + H.fmt(v.mapcm) + ' = ' + H.fmt(nf));
      steps.push('So the scale is 1 : ' + H.fmt(nf));
      return { answer: '1 : ' + H.fmt(nf), steps: steps };
    }), preview: (function (v, H) { if (v.mode === 'maptoreal') return v.mapcm + ' cm on a 1 : ' + v.n + ' map. Real distance = ?'; if (v.mode === 'realtomap') return v.real + ' ' + v.realUnit + ' in real life, scale 1 : ' + v.n + '. Map distance = ?'; return v.mapcm + ' cm on the map is ' + v.real + ' ' + v.realUnit + ' in real life. Scale = ?'; }) };
MC_CONFIG["unit-converter"] = { name: "Unit Converter", fields: [{"id": "val", "label": "Value to convert", "type": "number", "def": "4"}, {"id": "from", "label": "From", "type": "select", "def": "km", "options": [["mm", "Millimetres (mm)"], ["cm", "Centimetres (cm)"], ["m", "Metres (m)"], ["km", "Kilometres (km)"], ["mg", "Milligrams (mg)"], ["g", "Grams (g)"], ["kg", "Kilograms (kg)"], ["tonne", "Tonnes (t)"], ["ml", "Millilitres (ml)"], ["cl", "Centilitres (cl)"], ["l", "Litres (l)"], ["cm2", "Square centimetres (cm\u00b2)"], ["m2", "Square metres (m\u00b2)"], ["km2", "Square kilometres (km\u00b2)"], ["cm3", "Cubic centimetres (cm\u00b3)"], ["m3", "Cubic metres (m\u00b3)"], ["s", "Seconds"], ["min", "Minutes"], ["h", "Hours"], ["day", "Days"], ["week", "Weeks"]]}, {"id": "to", "label": "To", "type": "select", "def": "m", "options": [["mm", "Millimetres (mm)"], ["cm", "Centimetres (cm)"], ["m", "Metres (m)"], ["km", "Kilometres (km)"], ["mg", "Milligrams (mg)"], ["g", "Grams (g)"], ["kg", "Kilograms (kg)"], ["tonne", "Tonnes (t)"], ["ml", "Millilitres (ml)"], ["cl", "Centilitres (cl)"], ["l", "Litres (l)"], ["cm2", "Square centimetres (cm\u00b2)"], ["m2", "Square metres (m\u00b2)"], ["km2", "Square kilometres (km\u00b2)"], ["cm3", "Cubic centimetres (cm\u00b3)"], ["m3", "Cubic metres (m\u00b3)"], ["s", "Seconds"], ["min", "Minutes"], ["h", "Hours"], ["day", "Days"], ["week", "Weeks"]]}], example: {"val": 4, "from": "km", "to": "m"}, run: (function (v, H) {
      var U = {
        mm: { cat: 'length', f: 1 }, cm: { cat: 'length', f: 10 }, m: { cat: 'length', f: 1000 }, km: { cat: 'length', f: 1000000 },
        mg: { cat: 'mass', f: 1 }, g: { cat: 'mass', f: 1000 }, kg: { cat: 'mass', f: 1000000 }, tonne: { cat: 'mass', f: 1000000000 },
        ml: { cat: 'capacity', f: 1 }, cl: { cat: 'capacity', f: 10 }, l: { cat: 'capacity', f: 1000 },
        cm2: { cat: 'area', f: 1 }, m2: { cat: 'area', f: 10000 }, km2: { cat: 'area', f: 10000000000 },
        cm3: { cat: 'volume', f: 1 }, m3: { cat: 'volume', f: 1000000 },
        s: { cat: 'time', f: 1 }, min: { cat: 'time', f: 60 }, h: { cat: 'time', f: 3600 }, day: { cat: 'time', f: 86400 }, week: { cat: 'time', f: 604800 }
      };
      var D = { cm2: 'cm²', m2: 'm²', km2: 'km²', cm3: 'cm³', m3: 'm³', s: 'seconds', min: 'minutes', h: 'hours', day: 'days', week: 'weeks', tonne: 'tonnes' };
      function disp(u) { return D[u] || u; }
      var from = U[v.from], to = U[v.to];
      if (v.from === v.to) throw new Error('Those are the same unit, pick two different ones.');
      if (from.cat !== to.cat) throw new Error('You cannot convert ' + disp(v.from) + ' into ' + disp(v.to) + ', one measures ' + from.cat + ' and the other measures ' + to.cat + '.');
      var steps = ['Both units measure ' + from.cat + ', so the conversion is allowed'];
      var bigger = from.f >= to.f ? v.from : v.to;
      var smaller = from.f >= to.f ? v.to : v.from;
      var k = Math.max(from.f, to.f) / Math.min(from.f, to.f);
      steps.push('The link: 1 ' + disp(bigger) + ' = ' + H.fmt(k) + ' ' + disp(smaller));
      var result = v.val * from.f / to.f;
      if (from.f >= to.f) {
        steps.push('Going from the bigger unit to the smaller one, multiply: ' + H.fmt(v.val) + ' × ' + H.fmt(k) + ' = ' + H.fmt(result));
      } else {
        steps.push('Going from the smaller unit to the bigger one, divide: ' + H.fmt(v.val) + ' ÷ ' + H.fmt(k) + ' = ' + H.fmt(result));
      }
      steps.push('So ' + H.fmt(v.val) + ' ' + disp(v.from) + ' = ' + H.fmt(result) + ' ' + disp(v.to));
      var res = { answer: H.fmt(result) + ' ' + disp(v.to), steps: steps };
      if (from.cat === 'area') res.note = 'Area factors are squared: 1 m = 100 cm, but 1 m² = 100 × 100 = 10,000 cm², because both dimensions scale.';
      if (from.cat === 'volume') res.note = 'Volume factors are cubed: 1 m = 100 cm, but 1 m³ = 100 × 100 × 100 = 1,000,000 cm³.';
      return res;
    }), preview: (function (v, H) { var D = { cm2: 'cm²', m2: 'm²', km2: 'km²', cm3: 'cm³', m3: 'm³', s: 'seconds', min: 'minutes', h: 'hours', day: 'days', week: 'weeks', tonne: 'tonnes' }; return v.val + ' ' + (D[v.from] || v.from) + ' into ' + (D[v.to] || v.to); }) };
MC_CONFIG["area-and-perimeter-calculator"] = { name: "Area and Perimeter Calculator", fields: [{"id": "shape", "label": "Shape", "type": "select", "def": "rect", "cls": "mc-ghost", "options": [["rect", "Rectangle"], ["tri", "Triangle"], ["circle", "Circle"], ["trap", "Trapezium"], ["para", "Parallelogram"]]}, {"id": "A", "label": "Length, base, or radius", "type": "number", "def": "6", "gt": 0}, {"id": "B", "label": "Width or height", "type": "number", "def": "4", "min": 0, "showIf": {"shape": ["rect", "tri", "trap", "para"]}}, {"id": "C", "label": "The other parallel side", "type": "number", "def": "4", "min": 0, "showIf": {"shape": ["trap"]}}, {"id": "unit", "label": "Unit", "type": "select", "def": "cm", "options": [["cm", "Centimetres (cm)"], ["m", "Metres (m)"], ["mm", "Millimetres (mm)"]]}], example: {"shape": "rect", "A": 6, "B": 4, "C": 0, "unit": "cm"}, run: (function (v, H) {
      var u = v.unit, sq = v.unit + '²';
      var steps = [];
      if (v.shape === 'rect') {
        if (v.B <= 0) throw new Error('A rectangle needs a width, fill in the second measurement.');
        var area = v.A * v.B, per = 2 * (v.A + v.B);
        steps.push('Area of a rectangle = length × width: ' + H.fmt(v.A) + ' × ' + H.fmt(v.B) + ' = ' + H.fmt(area) + ' ' + sq);
        steps.push('Perimeter = 2 × (length + width): 2 × (' + H.fmt(v.A) + ' + ' + H.fmt(v.B) + ') = ' + H.fmt(per) + ' ' + u);
        return { answer: 'Area = ' + H.fmt(area) + ' ' + sq + ', perimeter = ' + H.fmt(per) + ' ' + u, steps: steps };
      }
      if (v.shape === 'tri') {
        if (v.B <= 0) throw new Error('A triangle needs its perpendicular height, fill in the second measurement.');
        var areaT = v.A * v.B / 2;
        steps.push('Area of a triangle = ½ × base × height');
        steps.push('½ × ' + H.fmt(v.A) + ' × ' + H.fmt(v.B) + ' = ' + H.fmt(areaT) + ' ' + sq);
        return {
          answer: 'Area = ' + H.fmt(areaT) + ' ' + sq, steps: steps,
          note: 'Perimeter of a triangle needs all three sides, which the area formula does not use, add the three sides together yourself.'
        };
      }
      if (v.shape === 'circle') {
        var r = v.A;
        var circ = 2 * Math.PI * r, areaC = Math.PI * r * r;
        steps.push('For a circle the first measurement is the radius: r = ' + H.fmt(r) + ' ' + u);
        steps.push('Circumference = 2πr = 2 × π × ' + H.fmt(r) + ' = ' + H.fmt(2 * r) + 'π = ' + H.fmt(circ) + ' ' + u);
        steps.push('Area = πr² = π × ' + H.fmt(r) + '² = ' + H.fmt(r * r) + 'π = ' + H.fmt(areaC) + ' ' + sq);
        return {
          answer: 'Circumference = ' + H.fmt(2 * r) + 'π ' + u + ' (≈ ' + H.fmt(circ) + ' ' + u + '), area = ' + H.fmt(r * r) + 'π ' + sq + ' (≈ ' + H.fmt(areaC) + ' ' + sq + ')',
          steps: steps,
          note: 'The π forms are exact, round the decimals only at the end of a question.'
        };
      }
      if (v.shape === 'trap') {
        if (v.B <= 0) throw new Error('A trapezium needs its perpendicular height, fill in the second measurement.');
        if (v.C <= 0) throw new Error('A trapezium needs both parallel sides, fill in the third measurement.');
        var areaTr = (v.A + v.C) / 2 * v.B;
        steps.push('Area of a trapezium = ½ × (a + b) × h, where a and b are the parallel sides');
        steps.push('½ × (' + H.fmt(v.A) + ' + ' + H.fmt(v.C) + ') × ' + H.fmt(v.B) + ' = ½ × ' + H.fmt(v.A + v.C) + ' × ' + H.fmt(v.B) + ' = ' + H.fmt(areaTr) + ' ' + sq);
        return {
          answer: 'Area = ' + H.fmt(areaTr) + ' ' + sq, steps: steps,
          note: 'Perimeter needs the two slanted sides as well, which the area formula does not use.'
        };
      }
      if (v.B <= 0) throw new Error('A parallelogram needs its perpendicular height, fill in the second measurement.');
      var areaP = v.A * v.B;
      steps.push('Area of a parallelogram = base × perpendicular height');
      steps.push(H.fmt(v.A) + ' × ' + H.fmt(v.B) + ' = ' + H.fmt(areaP) + ' ' + sq);
      return {
        answer: 'Area = ' + H.fmt(areaP) + ' ' + sq, steps: steps,
        note: 'The height must be the perpendicular height, not the slant side, and the perimeter needs that slant side, so add it separately.'
      };
    }), preview: (function (v, H) { var s = { rect: 'Rectangle, ' + v.A + ' by ' + v.B, tri: 'Triangle, base ' + v.A + ', height ' + v.B, circle: 'Circle, radius ' + v.A, trap: 'Trapezium, sides ' + v.A + ' and ' + v.C + ', height ' + v.B, para: 'Parallelogram, base ' + v.A + ', height ' + v.B }[v.shape]; return s + ' (' + v.unit + ')'; }), widget: (function (v, H) {
      var x = Number(v.A), y = Number(v.B), z = Number(v.C);
      var u = v.unit, PI = Math.PI;
      function nice(n) {
        var r = Math.round(n);
        return H.fmt(Math.abs(n - r) < 1e-9 ? r : Math.round(n * 100) / 100);
      }
      function chip(cx, cy, txt2, state) {
        var w = 20 + txt2.length * 7.5;
        return '<g class="mc-tri-el is-' + state + '"><rect class="mc-tri-chip" x="' + Math.round(cx - w / 2) + '" y="' + Math.round(cy - 15) + '" width="' + Math.round(w) + '" height="30" rx="15"></rect>' +
          '<text class="mc-tri-txt" x="' + Math.round(cx) + '" y="' + Math.round(cy) + '">' + txt2 + '</text></g>';
      }
      function fit(w0, h0) {
        var r = w0 / h0, c = false;
        if (r > 4) { w0 = 4; h0 = 1; c = true; }
        if (r < 0.25) { w0 = 1; h0 = 4; c = true; }
        var s = Math.min(320 / w0, 150 / h0);
        return { W: w0 * s, Hh: h0 * s, capped: c };
      }
      function hline(x1, y1, x2, y2) {
        return '<line x1="' + Math.round(x1) + '" y1="' + Math.round(y1) + '" x2="' + Math.round(x2) + '" y2="' + Math.round(y2) + '" stroke="#C05621" stroke-width="2.5" stroke-dasharray="5 6"></line>';
      }
      var oy = 206, inner = '', barF = '', barWhy = '', capped = false, tag = '';
      var xs = isFinite(x) ? H.fmt(x) : v.A, ys = isFinite(y) ? H.fmt(y) : v.B, zs = isFinite(z) ? H.fmt(z) : v.C;
      if (v.shape === 'circle') {
        var cOk = x > 0;
        inner = '<circle cx="300" cy="126" r="80" class="mc-tri-face" stroke="#2F6886" stroke-width="2.5"></circle>' +
          '<line x1="300" y1="126" x2="380" y2="126" stroke="#7C93A4" stroke-width="2"></line>' +
          '<circle cx="300" cy="126" r="3.5" fill="#2F6886"></circle>' +
          chip(341, 104, 'radius ' + xs, 'known') +
          chip(300, 168, cOk ? 'area ' + nice(PI * x * x) + ' ' + u + '²' : 'area ?', 'find');
        barF = cOk ? 'Area = π × ' + H.fmt(x) + '² = <b>' + nice(PI * x * x) + ' ' + u + '²</b>' : 'Area = π × r²';
        barWhy = cOk ? 'Circumference = 2π × ' + H.fmt(x) + ' = ' + nice(2 * PI * x) + ' ' + u + '.' : 'Circumference = 2π × r.';
      } else if (v.shape === 'trap') {
        var tOk = x > 0 && y > 0 && z > 0;
        var bw = tOk ? x : 6, tw = tOk ? z : 4, th = tOk ? y : 3;
        var f0 = fit(Math.max(bw, tw), th);
        capped = !tOk || f0.capped;
        var sc = f0.W / Math.max(bw, tw);
        var bW = bw * sc, tW = tw * sc, Hh = f0.Hh;
        inner = '<path class="mc-tri-face" stroke="#2F6886" stroke-width="2.5" d="M' + Math.round(300 - bW / 2) + ' ' + oy + 'L' + Math.round(300 + bW / 2) + ' ' + oy + 'L' + Math.round(300 + tW / 2) + ' ' + Math.round(oy - Hh) + 'L' + Math.round(300 - tW / 2) + ' ' + Math.round(oy - Hh) + 'Z"></path>' +
          hline(300, oy - Hh, 300, oy) +
          '<path class="mc-tri-right" d="M' + (300 - 14) + ' ' + oy + 'v-14h14"></path>' +
          chip(300, oy - Hh - 18, 'top ' + zs, 'known') +
          chip(300, oy + 22, 'bottom ' + xs, 'known') +
          chip(356, Math.round(oy - Hh / 2), 'height ' + ys, 'known') +
          chip(Math.max(96, Math.round(300 - Math.max(bW, tW) / 2 - 72)), Math.round(oy - Hh / 2), tOk ? 'area ' + nice((x + z) / 2 * y) + ' ' + u + '²' : 'area ?', 'find');
        barF = tOk ? 'Area = ½ × (' + H.fmt(x) + ' + ' + H.fmt(z) + ') × ' + H.fmt(y) + ' = <b>' + nice((x + z) / 2 * y) + ' ' + u + '²</b>' : 'Area = ½ × (a + b) × h';
        barWhy = 'Average the parallel sides, times the height.';
        tag = capped ? 'not to scale' : 'drawn to scale';
      } else {
        var ok2 = x > 0 && y > 0;
        var f1 = fit(ok2 ? x : 6, ok2 ? y : 4);
        capped = !ok2 || f1.capped;
        var W = f1.W, H2 = f1.Hh;
        var x0 = Math.round(300 - W / 2), x1 = Math.round(300 + W / 2), ty = Math.round(oy - H2);
        if (v.shape === 'rect') {
          inner = '<rect class="mc-tri-face" stroke="#2F6886" stroke-width="2.5" x="' + x0 + '" y="' + ty + '" width="' + Math.round(W) + '" height="' + Math.round(H2) + '"></rect>' +
            chip(300, oy + 22, 'length ' + xs, 'known') +
            chip(Math.min(556, x1 + 58), Math.round(oy - H2 / 2), 'width ' + ys, 'known') +
            chip(300, Math.round(oy - H2 / 2), ok2 ? 'area ' + nice(x * y) + ' ' + u + '²' : 'area ?', 'find');
          barF = ok2 ? 'Area = ' + H.fmt(x) + ' × ' + H.fmt(y) + ' = <b>' + nice(x * y) + ' ' + u + '²</b>' : 'Area = length × width';
          barWhy = ok2 ? 'Perimeter = 2 × (' + H.fmt(x) + ' + ' + H.fmt(y) + ') = ' + nice(2 * (x + y)) + ' ' + u + '.' : 'Perimeter = 2 × (length + width).';
        } else if (v.shape === 'tri') {
          inner = '<rect x="' + x0 + '" y="' + ty + '" width="' + Math.round(W) + '" height="' + Math.round(H2) + '" fill="rgba(47,104,134,.06)" stroke="#A9C2D1" stroke-width="1.5" stroke-dasharray="6 6"></rect>' +
            '<path class="mc-tri-face" stroke="#2F6886" stroke-width="2.5" d="M' + x0 + ' ' + oy + 'L' + x1 + ' ' + oy + 'L300 ' + ty + 'Z"></path>' +
            hline(300, ty, 300, oy) +
            '<path class="mc-tri-right" d="M' + (300 - 14) + ' ' + oy + 'v-14h14"></path>' +
            chip(300, oy + 22, 'base ' + xs, 'known') +
            chip(356, Math.round(oy - H2 / 2), 'height ' + ys, 'known') +
            chip(Math.max(96, x0 - 10), ty + 4, ok2 ? 'area ' + nice(x * y / 2) + ' ' + u + '²' : 'area ?', 'find');
          barF = ok2 ? 'Area = ½ × ' + H.fmt(x) + ' × ' + H.fmt(y) + ' = <b>' + nice(x * y / 2) + ' ' + u + '²</b>' : 'Area = ½ × base × height';
          barWhy = 'The triangle is half the dashed base × height rectangle.';
        } else {
          var sh = 50;
          var p0 = Math.round(300 - (W + sh) / 2);
          inner = '<path class="mc-tri-face" stroke="#2F6886" stroke-width="2.5" d="M' + p0 + ' ' + oy + 'L' + Math.round(p0 + W) + ' ' + oy + 'L' + Math.round(p0 + W + sh) + ' ' + ty + 'L' + Math.round(p0 + sh) + ' ' + ty + 'Z"></path>' +
            hline(p0 + sh, ty, p0 + sh, oy) +
            '<path class="mc-tri-right" d="M' + (p0 + sh - 14) + ' ' + oy + 'v-14h14"></path>' +
            chip(Math.round(p0 + W / 2), oy + 22, 'base ' + xs, 'known') +
            chip(Math.round(p0 + sh + 58), Math.round(oy - H2 / 2) - 24, 'height ' + ys, 'known') +
            chip(Math.round(p0 + (W + sh) / 2 + 20), Math.round(oy - H2 / 2) + 16, ok2 ? 'area ' + nice(x * y) + ' ' + u + '²' : 'area ?', 'find');
          barF = ok2 ? 'Area = ' + H.fmt(x) + ' × ' + H.fmt(y) + ' = <b>' + nice(x * y) + ' ' + u + '²</b>' : 'Area = base × perpendicular height';
          barWhy = 'Base times perpendicular height, like a pushed-over rectangle.';
        }
        tag = capped ? 'not to scale' : 'drawn to scale';
      }
      function tab(m, lbl) {
        var on = v.shape === m;
        return '<button type="button" class="mc-rule-tab' + (on ? ' is-on' : '') + '" data-mc-tap data-set="shape:' + m + '" aria-pressed="' + on + '">' + lbl + '</button>';
      }
      return '<div class="mc-rule-tabs" role="group" aria-label="Which shape">' +
        tab('rect', 'Rectangle') + tab('tri', 'Triangle') + tab('circle', 'Circle') + tab('trap', 'Trapezium') + tab('para', 'Parallelogram') +
        '</div>' +
        '<p class="mc-rule-line"><span class="mc-rule-f">' + barF + '</span><span class="mc-rule-why">' + barWhy + '</span></p>' +
        '<p class="mc-tri-hint">The shape is drawn to your measurements. Green chips are what you typed, orange is what gets worked out.</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 246" role="group" aria-label="Shape drawn from your measurements">' + inner +
        (tag ? '<text class="mc-tri-scale" x="592" y="242" text-anchor="end">' + tag + '</text>' : '') + '</svg>';
    }), labels: (function (v, H) {
      if (v.shape === 'rect') return { A: 'Length', B: 'Width' };
      if (v.shape === 'tri') return { A: 'Base', B: 'Perpendicular height' };
      if (v.shape === 'circle') return { A: 'Radius' };
      if (v.shape === 'trap') return { A: 'One parallel side', B: 'Perpendicular height', C: 'The other parallel side' };
      return { A: 'Base', B: 'Perpendicular height' };
    }) };
MC_CONFIG["volume-and-surface-area-calculator"] = { name: "Volume and Surface Area Calculator", fields: [{"id": "solid", "label": "Solid", "type": "select", "def": "cuboid", "options": [["cuboid", "Cuboid"], ["cylinder", "Cylinder"], ["sphere", "Sphere"], ["cone", "Cone"], ["prism", "Triangular prism"]]}, {"id": "A", "label": "Length / radius / triangle base", "type": "number", "def": "2", "gt": 0}, {"id": "B", "label": "Width / height", "type": "number", "def": "3", "min": 0, "showIf": {"solid": ["cuboid", "cylinder", "cone", "prism"]}}, {"id": "C", "label": "Height / prism length", "type": "number", "def": "4", "min": 0, "showIf": {"solid": ["cuboid", "prism"]}}, {"id": "unit", "label": "Unit", "type": "select", "def": "cm", "options": [["cm", "Centimetres (cm)"], ["m", "Metres (m)"], ["mm", "Millimetres (mm)"]]}], example: {"solid": "cuboid", "A": 2, "B": 3, "C": 4, "unit": "cm"}, run: (function (v, H) {
      var cu = v.unit + '³', sq = v.unit + '²';
      var steps = [];
      if (v.solid === 'cuboid') {
        if (v.B <= 0 || v.C <= 0) throw new Error('A cuboid needs all three measurements: length, width and height.');
        var V = v.A * v.B * v.C;
        var SA = 2 * (v.A * v.B + v.A * v.C + v.B * v.C);
        steps.push('Volume of a cuboid = length × width × height: ' + H.fmt(v.A) + ' × ' + H.fmt(v.B) + ' × ' + H.fmt(v.C) + ' = ' + H.fmt(V) + ' ' + cu);
        steps.push('Surface area = 2 × (lw + lh + wh): 2 × (' + H.fmt(v.A * v.B) + ' + ' + H.fmt(v.A * v.C) + ' + ' + H.fmt(v.B * v.C) + ') = ' + H.fmt(SA) + ' ' + sq);
        return { answer: 'Volume = ' + H.fmt(V) + ' ' + cu + ', surface area = ' + H.fmt(SA) + ' ' + sq, steps: steps };
      }
      if (v.solid === 'cylinder') {
        if (v.B <= 0) throw new Error('A cylinder needs its height in the second measurement (radius goes first).');
        var r = v.A, h = v.B;
        var Vc = Math.PI * r * r * h;
        var SAc = 2 * Math.PI * r * r + 2 * Math.PI * r * h;
        steps.push('Volume of a cylinder = πr²h: π × ' + H.fmt(r) + '² × ' + H.fmt(h) + ' = ' + H.fmt(Vc) + ' ' + cu);
        steps.push('Surface area = 2πr² + 2πrh (two circles plus the curved face): ' + H.fmt(2 * Math.PI * r * r) + ' + ' + H.fmt(2 * Math.PI * r * h) + ' = ' + H.fmt(SAc) + ' ' + sq);
        return { answer: 'Volume = ' + H.fmt(Vc) + ' ' + cu + ', surface area = ' + H.fmt(SAc) + ' ' + sq, steps: steps };
      }
      if (v.solid === 'sphere') {
        var rs = v.A;
        var Vs = 4 / 3 * Math.PI * rs * rs * rs;
        var SAs = 4 * Math.PI * rs * rs;
        steps.push('Volume of a sphere = 4/3 πr³: 4/3 × π × ' + H.fmt(rs) + '³ = ' + H.fmt(Vs) + ' ' + cu);
        steps.push('Surface area = 4πr²: 4 × π × ' + H.fmt(rs) + '² = ' + H.fmt(SAs) + ' ' + sq);
        return { answer: 'Volume = ' + H.fmt(Vs) + ' ' + cu + ', surface area = ' + H.fmt(SAs) + ' ' + sq, steps: steps };
      }
      if (v.solid === 'cone') {
        if (v.B <= 0) throw new Error('A cone needs its perpendicular height in the second measurement (radius goes first).');
        var rc = v.A, hc = v.B;
        var Vk = Math.PI * rc * rc * hc / 3;
        var l = Math.sqrt(rc * rc + hc * hc);
        var SAk = Math.PI * rc * rc + Math.PI * rc * l;
        steps.push('Volume of a cone = 1/3 πr²h: 1/3 × π × ' + H.fmt(rc) + '² × ' + H.fmt(hc) + ' = ' + H.fmt(Vk) + ' ' + cu);
        steps.push('The curved surface needs the slant height, from Pythagoras: l = √(' + H.fmt(rc) + '² + ' + H.fmt(hc) + '²) = √' + H.fmt(rc * rc + hc * hc) + ' = ' + H.fmt(l));
        steps.push('Surface area = πr² + πrl: ' + H.fmt(Math.PI * rc * rc) + ' + ' + H.fmt(Math.PI * rc * l) + ' = ' + H.fmt(SAk) + ' ' + sq);
        return { answer: 'Volume = ' + H.fmt(Vk) + ' ' + cu + ', surface area = ' + H.fmt(SAk) + ' ' + sq, steps: steps };
      }
      if (v.B <= 0 || v.C <= 0) throw new Error('A triangular prism needs the triangle base, the triangle height and the prism length.');
      var Vp = v.A * v.B / 2 * v.C;
      steps.push('Volume of a prism = area of cross-section × length');
      steps.push('Cross-section (triangle) = ½ × ' + H.fmt(v.A) + ' × ' + H.fmt(v.B) + ' = ' + H.fmt(v.A * v.B / 2) + ' ' + sq);
      steps.push('Volume = ' + H.fmt(v.A * v.B / 2) + ' × ' + H.fmt(v.C) + ' = ' + H.fmt(Vp) + ' ' + cu);
      return {
        answer: 'Volume = ' + H.fmt(Vp) + ' ' + cu, steps: steps,
        note: 'Surface area of a prism needs all three sides of the triangle, which the volume formula does not use.'
      };
    }), preview: (function (v, H) { var s = { cuboid: 'Cuboid, ' + v.A + ' by ' + v.B + ' by ' + v.C, cylinder: 'Cylinder, radius ' + v.A + ', height ' + v.B, sphere: 'Sphere, radius ' + v.A, cone: 'Cone, radius ' + v.A + ', height ' + v.B, prism: 'Triangular prism, base ' + v.A + ', height ' + v.B + ', length ' + v.C }[v.solid]; return s + ' (' + v.unit + ')'; }) };
MC_CONFIG["circle-calculator"] = { name: "Circle Calculator", fields: [{"id": "given", "label": "What you know", "type": "select", "def": "radius", "options": [["radius", "The radius"], ["diameter", "The diameter"], ["circumference", "The circumference"], ["area", "The area"]]}, {"id": "value", "label": "Its value", "type": "number", "def": "5", "gt": 0}, {"id": "unit", "label": "Unit", "type": "select", "def": "cm", "options": [["cm", "Centimetres (cm)"], ["m", "Metres (m)"], ["mm", "Millimetres (mm)"]]}], example: {"given": "radius", "value": 5, "unit": "cm"}, run: (function (v, H) {
      var u = v.unit, sq = v.unit + '²';
      var steps = [], r;
      if (v.given === 'radius') {
        r = v.value;
        steps.push('The radius is given: r = ' + H.fmt(r) + ' ' + u);
      } else if (v.given === 'diameter') {
        r = v.value / 2;
        steps.push('The radius is half the diameter: r = ' + H.fmt(v.value) + ' ÷ 2 = ' + H.fmt(r) + ' ' + u);
      } else if (v.given === 'circumference') {
        r = v.value / (2 * Math.PI);
        steps.push('Circumference = 2πr, so r = C ÷ 2π: ' + H.fmt(v.value) + ' ÷ ' + H.fmt(2 * Math.PI) + ' = ' + H.fmt(r) + ' ' + u);
      } else {
        r = Math.sqrt(v.value / Math.PI);
        steps.push('Area = πr², so r² = A ÷ π: ' + H.fmt(v.value) + ' ÷ π = ' + H.fmt(v.value / Math.PI));
        steps.push('r = √' + H.fmt(v.value / Math.PI) + ' = ' + H.fmt(r) + ' ' + u);
      }
      var d = 2 * r, C = 2 * Math.PI * r, A = Math.PI * r * r;
      steps.push('Diameter = 2r = ' + H.fmt(d) + ' ' + u);
      steps.push('Circumference = 2πr = ' + H.fmt(d) + 'π = ' + H.fmt(C) + ' ' + u);
      steps.push('Area = πr² = ' + H.fmt(r * r) + 'π = ' + H.fmt(A) + ' ' + sq);
      return {
        answer: 'Radius ' + H.fmt(r) + ' ' + u + ', diameter ' + H.fmt(d) + ' ' + u + ', circumference ' + H.fmt(d) + 'π ' + u + ' (≈ ' + H.fmt(C) + ' ' + u + '), area ' + H.fmt(r * r) + 'π ' + sq + ' (≈ ' + H.fmt(A) + ' ' + sq + ')',
        steps: steps,
        note: 'Keep answers in terms of π until the final line, rounding early is how circle answers drift.'
      };
    }), preview: (function (v, H) { return 'A circle with ' + v.given + ' ' + v.value + ' ' + v.unit + (v.given === 'area' ? '²' : ''); }) };
MC_CONFIG["angles-calculator"] = { name: "Angles Calculator", fields: [{"id": "mode", "label": "What to find", "type": "select", "def": "polygon", "cls": "mc-ghost", "options": [["polygon", "Polygon angles (n sides)"], ["triangle", "Triangle: missing angle"], ["line", "On a straight line"], ["point", "Around a point"]]}, {"id": "n", "label": "Number of sides", "type": "number", "def": "6", "min": 3, "int": true, "max": 1000, "showIf": {"mode": ["polygon"]}}, {"id": "a1", "label": "First known angle (degrees)", "type": "number", "def": "50", "min": 0, "showIf": {"mode": ["triangle", "line", "point"]}}, {"id": "a2", "label": "Second known angle (degrees)", "type": "number", "def": "60", "min": 0, "showIf": {"mode": ["triangle"]}}], example: {"mode": "polygon", "n": 6, "a1": 0, "a2": 0}, run: (function (v, H) {
      var steps = [];
      if (v.mode === 'polygon') {
        var sum = (v.n - 2) * 180;
        var each = sum / v.n;
        var ext = 360 / v.n;
        steps.push('A shape with ' + v.n + ' sides splits into ' + (v.n - 2) + ' triangles');
        steps.push('Interior angle sum: ' + (v.n - 2) + ' × 180 = ' + H.fmt(sum) + '°');
        steps.push('If the shape is regular, each interior angle: ' + H.fmt(sum) + ' ÷ ' + v.n + ' = ' + H.fmt(each) + '°');
        steps.push('Each exterior angle: 360 ÷ ' + v.n + ' = ' + H.fmt(ext) + '°');
        return {
          answer: 'Interior sum ' + H.fmt(sum) + '°, each interior ' + H.fmt(each) + '°, each exterior ' + H.fmt(ext) + '°',
          steps: steps,
          note: 'Exterior angles of any polygon always add up to 360°.'
        };
      }
      if (v.mode === 'triangle') {
        if (v.a1 <= 0 || v.a2 <= 0) throw new Error('Enter both known angles (each bigger than 0).');
        if (v.a1 + v.a2 >= 180) throw new Error('Those two angles already make 180° or more, a triangle cannot hold them.');
        var third = 180 - v.a1 - v.a2;
        steps.push('Angles in a triangle add up to 180°');
        steps.push('Add the known angles: ' + H.fmt(v.a1) + ' + ' + H.fmt(v.a2) + ' = ' + H.fmt(v.a1 + v.a2) + '°');
        steps.push('Take that from 180: 180 − ' + H.fmt(v.a1 + v.a2) + ' = ' + H.fmt(third) + '°');
        return { answer: H.fmt(third) + '°', steps: steps };
      }
      if (v.mode === 'line') {
        if (v.a1 <= 0 || v.a1 >= 180) throw new Error('Enter the known angle, between 0 and 180.');
        steps.push('Angles on a straight line add up to 180°');
        steps.push('180 − ' + H.fmt(v.a1) + ' = ' + H.fmt(180 - v.a1) + '°');
        return { answer: H.fmt(180 - v.a1) + '°', steps: steps };
      }
      if (v.a1 <= 0 || v.a1 >= 360) throw new Error('Enter the known angle, between 0 and 360.');
      steps.push('Angles around a point add up to 360°');
      steps.push('360 − ' + H.fmt(v.a1) + ' = ' + H.fmt(360 - v.a1) + '°');
      return { answer: H.fmt(360 - v.a1) + '°', steps: steps };
    }), preview: (function (v, H) { if (v.mode === 'polygon') return 'A polygon with ' + v.n + ' sides'; if (v.mode === 'triangle') return 'Triangle angles ' + v.a1 + '° and ' + v.a2 + '°. Third = ?'; if (v.mode === 'line') return v.a1 + '° on a straight line. The rest = ?'; return v.a1 + '° around a point. The rest = ?'; }), widget: (function (v, H) {
      var D = Math.PI / 180;
      var a1 = Number(v.a1), a2 = Number(v.a2), n1 = Number(v.n);
      function P(cx, cy, ang, r) { return [cx + r * Math.cos(ang * D), cy - r * Math.sin(ang * D)]; }
      function arc(cx, cy, r, aFrom, aTo, cls) {
        if (aTo < aFrom) aTo += 360;
        var p1 = P(cx, cy, aFrom, r), p2 = P(cx, cy, aTo, r);
        var large = (aTo - aFrom) > 180 ? 1 : 0;
        return '<path class="mc-tri-arc is-' + cls + '" d="M' + p1[0].toFixed(1) + ' ' + p1[1].toFixed(1) + 'A' + r + ' ' + r + ' 0 ' + large + ' 0 ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1) + '"></path>';
      }
      function chip(cx, cy, txt2, state) {
        var w = 20 + txt2.length * 7.5;
        return '<g class="mc-tri-el is-' + state + '"><rect class="mc-tri-chip" x="' + Math.round(cx - w / 2) + '" y="' + Math.round(cy - 15) + '" width="' + Math.round(w) + '" height="30" rx="15"></rect>' +
          '<text class="mc-tri-txt" x="' + Math.round(cx) + '" y="' + Math.round(cy) + '">' + txt2 + '</text></g>';
      }
      function seg(x1, y1, x2, y2, dash) {
        return '<path class="mc-tri-right"' + (dash ? ' stroke-dasharray="5 6"' : '') + ' d="M' + Math.round(x1) + ' ' + Math.round(y1) + 'L' + Math.round(x2) + ' ' + Math.round(y2) + '"></path>';
      }
      function mang(x1, y1, x2, y2) { return Math.atan2(-(y2 - y1), x2 - x1) / D; }
      var inner = '', barF = '', barWhy = '', capped = false;
      if (v.mode === 'triangle') {
        var tOk = a1 > 0 && a2 > 0 && a1 + a2 < 180;
        var third = tOk ? 180 - a1 - a2 : null;
        var dA = tOk ? a1 : 50, dB = tOk ? a2 : 60;
        if (!tOk || dA < 6 || dB < 6 || 180 - dA - dB < 6) { dA = 50; dB = 60; capped = true; }
        var tA = Math.tan(dA * D), tB = Math.tan(dB * D);
        var hh = tA * tB / (tA + tB), ax0 = hh / tA;
        var minX = Math.min(0, ax0), maxX = Math.max(1, ax0);
        var s = Math.min(360 / (maxX - minX), 164 / hh);
        var oy = 228;
        var AX = Math.round((600 - (maxX - minX) * s) / 2 - minX * s), BX = Math.round(AX + s);
        var CX = Math.round(AX + ax0 * s), CY = Math.round(oy - hh * s);
        var angCA = mang(CX, CY, AX, oy), angCB = mang(CX, CY, BX, oy);
        if (angCB < angCA) angCB += 360;
        inner = '<path class="mc-tri-face" d="M' + AX + ' ' + oy + 'L' + BX + ' ' + oy + 'L' + CX + ' ' + CY + 'Z"></path>' +
          arc(AX, oy, 26, 0, dA, 'known') + arc(BX, oy, 26, 180 - dB, 180, 'known') +
          arc(CX, CY, 26, angCA, angCB, 'find') +
          chip.apply(null, P(AX, oy, dA / 2, 68).concat([(isFinite(a1) ? H.fmt(a1) : v.a1) + '°', 'known'])) +
          chip.apply(null, P(BX, oy, 180 - dB / 2, 68).concat([(isFinite(a2) ? H.fmt(a2) : v.a2) + '°', 'known'])) +
          chip.apply(null, P(CX, CY, (angCA + angCB) / 2, 62).concat([tOk ? H.fmt(third) + '°' : '?', 'find']));
        barF = tOk ? '180 − ' + H.fmt(a1) + ' − ' + H.fmt(a2) + ' = <b>' + H.fmt(third) + '°</b>' : '180 − the two knowns = the third angle';
        barWhy = 'Angles in a triangle add up to 180°.';
      } else if (v.mode === 'line') {
        var lOk = a1 > 0 && a1 < 180;
        var la = lOk ? a1 : 110;
        if (!lOk) capped = true;
        var rest = lOk ? 180 - a1 : null;
        var O = [300, 208];
        var rp = P(O[0], O[1], la, 150);
        inner = seg(70, O[1], 530, O[1]) + seg(O[0], O[1], rp[0], rp[1]) +
          arc(O[0], O[1], 34, 0, la, 'known') + arc(O[0], O[1], 48, la, 180, 'find') +
          chip.apply(null, P(O[0], O[1], la / 2, 82).concat([(isFinite(a1) ? H.fmt(a1) : v.a1) + '°', 'known'])) +
          chip.apply(null, P(O[0], O[1], la + (180 - la) / 2, 96).concat([lOk ? H.fmt(rest) + '°' : '?', 'find']));
        barF = lOk ? '180 − ' + H.fmt(a1) + ' = <b>' + H.fmt(rest) + '°</b>' : '180 − the known angle = the rest';
        barWhy = 'Angles on a straight line add up to 180°.';
      } else if (v.mode === 'point') {
        var pOk = a1 > 0 && a1 < 360;
        var pa = pOk ? a1 : 250;
        if (!pOk) capped = true;
        var rest2 = pOk ? 360 - a1 : null;
        var O2 = [300, 148];
        var r1p = P(O2[0], O2[1], 90, 108), r2p = P(O2[0], O2[1], 90 - pa, 108);
        inner = seg(O2[0], O2[1], r1p[0], r1p[1]) + seg(O2[0], O2[1], r2p[0], r2p[1]) +
          arc(O2[0], O2[1], 36, 90 - pa, 90, 'known') + arc(O2[0], O2[1], 54, 90, 450 - pa, 'find') +
          chip.apply(null, P(O2[0], O2[1], 90 - pa / 2, 74).concat([(isFinite(a1) ? H.fmt(a1) : v.a1) + '°', 'known'])) +
          chip.apply(null, P(O2[0], O2[1], 90 + (360 - pa) / 2, 88).concat([pOk ? H.fmt(rest2) + '°' : '?', 'find']));
        barF = pOk ? '360 − ' + H.fmt(a1) + ' = <b>' + H.fmt(rest2) + '°</b>' : '360 − the known angle = the rest';
        barWhy = 'Angles around a point add up to 360°.';
      } else {
        var gOk = isFinite(n1) && n1 >= 3;
        var nD = gOk ? Math.min(20, Math.round(n1)) : 6;
        if (!gOk || n1 > 20 || Math.round(n1) !== n1) capped = true;
        var sum = gOk ? (n1 - 2) * 180 : null;
        var each = gOk ? sum / n1 : null;
        var ext = gOk ? 360 / n1 : null;
        var ctr = [300, 146], R = 90, sA = 360 / nD;
        var pts = [], k;
        for (k = 0; k < nD; k++) pts.push(P(ctr[0], ctr[1], 90 + k * sA, R));
        var d2 = 'M' + pts.map(function (p) { return p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join('L') + 'Z';
        var k0 = ((Math.round(-90 / sA) % nD) + nD) % nD;
        var V = pts[k0], Vm = pts[(k0 - 1 + nD) % nD], Vp = pts[(k0 + 1) % nD];
        /* interior arc: the non-reflex span between the two edge directions */
        var toPrev = mang(V[0], V[1], Vm[0], Vm[1]), toNext = mang(V[0], V[1], Vp[0], Vp[1]);
        var spanPN = ((toPrev - toNext) % 360 + 360) % 360;
        var inFrom = spanPN <= 180 ? toNext : toPrev, inTo = spanPN <= 180 ? toPrev : toNext;
        var extDir = mang(Vm[0], Vm[1], V[0], V[1]);
        var E = P(V[0], V[1], extDir, 58);
        var aSide = mang(V[0], V[1], Vp[0], Vp[1]);
        var toC = mang(V[0], V[1], ctr[0], ctr[1]);
        inner = '<path class="mc-tri-face" stroke="#7C93A4" stroke-width="2" d="' + d2 + '"></path>' +
          seg(V[0], V[1], E[0], E[1], true) +
          arc(V[0], V[1], 24, inFrom, inTo, 'find') +
          arc(V[0], V[1], 30, extDir, aSide, 'known') +
          chip.apply(null, P(V[0], V[1], toC, 52).concat([gOk ? 'interior ' + H.fmt(each) + '°' : 'interior ?', 'find'])) +
          chip.apply(null, P(V[0], V[1], (extDir + aSide) / 2, 72).concat([gOk ? 'exterior ' + H.fmt(ext) + '°' : 'exterior ?', 'known'])) +
          chip(150, ctr[1], gOk ? 'sum ' + H.fmt(sum) + '°' : 'sum ?', 'idle');
        barF = gOk ? '(' + H.fmt(n1) + ' − 2) × 180 = ' + H.fmt(sum) + '°, each interior = <b>' + H.fmt(each) + '°</b>' : '(n − 2) × 180 = the interior angle sum';
        barWhy = 'A polygon with n sides splits into n − 2 triangles.';
      }
      function tab(m, lbl) {
        var on = v.mode === m;
        return '<button type="button" class="mc-rule-tab' + (on ? ' is-on' : '') + '" data-mc-tap data-set="mode:' + m + '" aria-pressed="' + on + '">' + lbl + '</button>';
      }
      return '<div class="mc-rule-tabs" role="group" aria-label="Which angle fact">' +
        tab('triangle', 'Triangle') + tab('line', 'Straight line') + tab('point', 'Round a point') + tab('polygon', 'Polygon') +
        '</div>' +
        '<p class="mc-rule-line"><span class="mc-rule-f">' + barF + '</span><span class="mc-rule-why">' + barWhy + '</span></p>' +
        '<p class="mc-tri-hint">Drawn with the real angles, so the picture is the sense check. Green is what you typed, orange is what gets found.</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 268" role="group" aria-label="Angle diagram drawn from your numbers">' + inner +
        '<text class="mc-tri-scale" x="592" y="264" text-anchor="end">' + (capped ? 'not to scale' : 'drawn to scale') + '</text></svg>';
    }) };
MC_CONFIG["pythagoras-calculator"] = { name: "Pythagoras Calculator", fields: [{"id": "mode", "label": "Which side is missing", "type": "select", "def": "hyp", "cls": "mc-ghost", "options": [["hyp", "The hypotenuse (longest side)"], ["side", "A shorter side"]]}, {"id": "view", "label": "Diagram view", "type": "select", "def": "tri", "cls": "mc-ghost", "options": [["tri", "Triangle drawn to scale"], ["sq", "Why it works (squares)"]]}, {"id": "x", "label": "First side", "type": "number", "def": "3", "gt": 0}, {"id": "y", "label": "Second side", "type": "number", "def": "4", "gt": 0}], example: {"mode": "hyp", "view": "tri", "x": 3, "y": 4}, run: (function (v, H) {
      var steps = [];
      function rootOut(sq) {
        var r = Math.round(Math.sqrt(sq));
        if (r * r === sq) {
          steps.push('Square root: √' + H.fmt(sq) + ' = ' + H.fmt(r));
          return H.fmt(r);
        }
        var approx = H.fmt(Math.sqrt(sq));
        if (Number.isInteger(sq)) {
          var s = Math.floor(Math.sqrt(sq)), best = 1;
          for (var k = s; k >= 2; k--) { if (sq % (k * k) === 0) { best = k; break; } }
          if (best > 1) {
            var inner = sq / (best * best);
            steps.push('√' + H.fmt(sq) + ' is not whole. Simplify: √' + H.fmt(sq) + ' = √' + H.fmt(best * best) + ' × √' + H.fmt(inner) + ' = ' + H.fmt(best) + '√' + H.fmt(inner));
            steps.push('As a decimal: ' + H.fmt(best) + '√' + H.fmt(inner) + ' ≈ ' + approx);
            return H.fmt(best) + '√' + H.fmt(inner) + ' (≈ ' + approx + ')';
          }
        }
        steps.push('Square root: √' + H.fmt(sq) + ' ≈ ' + approx);
        return (Number.isInteger(sq) ? '√' + H.fmt(sq) + ' (≈ ' + approx + ')' : approx);
      }
      if (v.mode === 'hyp') {
        var c2 = v.x * v.x + v.y * v.y;
        steps.push('For the hypotenuse, square the two sides and ADD: c² = ' + H.fmt(v.x) + '² + ' + H.fmt(v.y) + '² = ' + H.fmt(v.x * v.x) + ' + ' + H.fmt(v.y * v.y) + ' = ' + H.fmt(c2));
        var ans = rootOut(c2);
        return { answer: ans, steps: steps, note: 'The answer is in the same unit as the sides you typed in.' };
      }
      if (v.x <= v.y) throw new Error('The hypotenuse is always the longest side, the first number must be bigger than the second.');
      var b2 = v.x * v.x - v.y * v.y;
      steps.push('For a shorter side, square and SUBTRACT: b² = ' + H.fmt(v.x) + '² − ' + H.fmt(v.y) + '² = ' + H.fmt(v.x * v.x) + ' − ' + H.fmt(v.y * v.y) + ' = ' + H.fmt(b2));
      var ans2 = rootOut(b2);
      return { answer: ans2, steps: steps, note: 'The answer is in the same unit as the sides you typed in.' };
    }), preview: (function (v, H) { return v.mode === 'hyp' ? 'Shorter sides ' + v.x + ' and ' + v.y + '. Hypotenuse = ?' : 'Hypotenuse ' + v.x + ', one side ' + v.y + '. Other side = ?'; }), widget: (function (v, H) {
      var findHyp = v.mode === 'hyp';
      var sqView = v.view === 'sq';
      var x = Number(v.x), y = Number(v.y);
      var have = isFinite(x) && x > 0 && isFinite(y) && y > 0;
      var valid = have && (findHyp || x > y);
      function nice(n) {
        var r = Math.round(n);
        return H.fmt(Math.abs(n - r) < 1e-9 ? r : Math.round(n * 100) / 100);
      }
      var base = have ? (findHyp ? x : y) : null;
      var missSq = valid && !findHyp ? x * x - y * y : null;
      var hypSq = valid && findHyp ? x * x + y * y : null;
      var ans = valid ? Math.sqrt(findHyp ? hypSq : missSq) : null;
      var exact = valid && Math.round(ans) === ans;
      /* '= 5', '≈ 20.1' or '= ?': the joiner travels with the value so a chip
         never reads "= ≈ 20.1" */
      var ansTxt = valid ? (exact ? '= ' + H.fmt(ans) : '≈ ' + nice(ans)) : '= ?';
      var vert = findHyp ? (have ? y : null) : ans;
      var el = H.triEl;
      var svg;
      if (!sqView) {
        var db = base || 4, da = vert || 3, capped = false;
        var r0 = db / da;
        if (r0 > 4) { db = 4; da = 1; capped = true; }
        if (r0 < 0.25) { db = 1; da = 4; capped = true; }
        var s = Math.min(280 / db, 175 / da);
        var W = db * s, Hh = da * s;
        var vertTxt = 'Shorter side ' + (findHyp ? (have ? '= ' + H.fmt(y) : '= ' + v.y) : ansTxt);
        /* the vertical side's chip sits fully LEFT of its line (its ? badge
           lands 20px left of the line too), so it can never collide with the
           hypotenuse chip however narrow the triangle gets */
        var wv = 20 + vertTxt.length * 7.5;
        var ox = Math.max(Math.round(wv + 45), Math.round((560 - W) / 2)), oy = 240;
        var ay = Math.round(oy - Hh), bx = Math.round(ox + W);
        function ln(x1, y1, x2, y2) {
          return '<line class="mc-tri-hit" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"></line>' +
            '<line class="mc-tri-line" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"></line>';
        }
        var L = Math.sqrt(W * W + Hh * Hh);
        var hx = Math.round((ox + bx) / 2 + 40 * Hh / L), hy = Math.round((ay + oy) / 2 - 40 * W / L);
        var hypEl = el(hx, hy, 'Hypotenuse ' + (findHyp ? ansTxt : (have ? '= ' + H.fmt(x) : '= ' + v.x)), findHyp ? 'find' : 'known',
          'mode:side', 'mode:hyp',
          'Mark the hypotenuse as known, so a shorter side is missing', 'Find the hypotenuse', ln(ox, ay, bx, oy));
        var vertEl = el(Math.round(ox - wv / 2 - 37), Math.round((ay + oy) / 2), vertTxt, findHyp ? 'known' : 'find',
          'mode:' + v.mode, 'mode:side',
          'This shorter side is known', 'Find a shorter side', ln(ox, oy, ox, ay));
        var baseEl = el(Math.round(ox + W / 2), oy + 6, 'Shorter side = ' + (have ? H.fmt(base) : (findHyp ? v.x : v.y)), 'known',
          'mode:' + v.mode, 'mode:side',
          'This shorter side is known', 'Find a shorter side', ln(ox, oy, bx, oy));
        svg = '<svg class="mc-tri" viewBox="0 0 560 272" role="group" aria-label="Right angled triangle drawn from your numbers, tap the sides to set which one is missing">' +
          '<path class="mc-tri-face" d="M' + ox + ' ' + oy + 'L' + bx + ' ' + oy + 'L' + ox + ' ' + ay + 'Z"></path>' +
          '<path class="mc-tri-right" d="M' + ox + ' ' + (oy - 16) + 'h16v16"></path>' +
          '<text class="mc-tri-scale" x="552" y="' + (oy + 14) + '" text-anchor="end">' + (valid && !capped ? 'drawn to scale' : 'not to scale') + '</text>' +
          hypEl + vertEl + baseEl + '</svg>';
      } else {
        /* fixed 3-4-5 proof layout, the typed numbers as the square areas */
        function bdg(cx, cy, state, set, aria) {
          return '<g class="mc-tri-badge is-' + state + '" role="button" tabindex="0" data-mc-tap data-set="' + set + '" aria-label="' + aria + '">' +
            '<circle class="mc-tri-bhit" cx="' + cx + '" cy="' + cy + '" r="22"></circle>' +
            '<circle cx="' + cx + '" cy="' + cy + '" r="13"></circle>' +
            '<text x="' + cx + '" y="' + cy + '">?</text></g>';
        }
        function sqEl(d, state, set, aria, lx, ly, lbl, sub) {
          return '<g class="mc-tri-el is-' + state + '" role="button" tabindex="0" data-mc-tap data-set="' + set + '" aria-label="' + aria + '">' +
            '<path class="mc-sq" d="' + d + '"></path>' +
            '<text class="mc-sq-lbl" x="' + lx + '" y="' + ly + '" font-size="15">' + lbl + '</text>' +
            '<text class="mc-sq-sub" x="' + lx + '" y="' + (ly + 21) + '">' + sub + '</text></g>';
        }
        /* the bottom square is drawn bigger than the left one, so in hyp mode
           the larger typed side labels the bottom square: 3 and 4 must never
           render as 3² on the visibly bigger square */
        var big = have ? Math.max(x, y) : null, small = have ? Math.min(x, y) : null;
        var baseLbl = have ? (findHyp ? H.fmt(big) + '² = ' + nice(big * big) : H.fmt(y) + '² = ' + nice(y * y)) : 'a² = ?';
        var leftLbl = findHyp ? (have ? H.fmt(small) + '² = ' + nice(small * small) : 'b² = ?') : ('b² = ' + (valid ? nice(missSq) : '?'));
        var leftSub = findHyp ? 'side × side' : (valid ? nice(x * x) + ' − ' + nice(y * y) : 'c² − a²');
        var hypLbl = findHyp ? ('c² = ' + (valid ? nice(hypSq) : '?')) : (have ? H.fmt(x) + '² = ' + nice(x * x) : 'c² = ?');
        var hypSub = findHyp ? (valid ? nice(x * x) + ' + ' + nice(y * y) : 'a² + b²') : 'side × side';
        svg = '<svg class="mc-tri" viewBox="0 0 560 348" style="max-width:600px" role="group" aria-label="Right angled triangle with a square drawn on each side, tap a square to set which side is missing">' +
          sqEl('M238 212L342 212L342 316L238 316Z', 'known', 'mode:' + v.mode,
            'This shorter side is known', 290, 256, baseLbl, 'side × side') +
          sqEl('M238 212L238 134L160 134L160 212Z', findHyp ? 'known' : 'find', 'mode:' + v.mode,
            findHyp ? 'This shorter side is known' : 'This shorter side is being found', 199, 166, leftLbl, leftSub) +
          sqEl('M238 134L342 212L420 108L316 30Z', findHyp ? 'find' : 'known', findHyp ? 'mode:hyp' : 'mode:side',
            findHyp ? 'The hypotenuse is being found' : 'The hypotenuse is known', 329, 112, hypLbl, hypSub) +
          '<path class="mc-tri-face" d="M238 212L342 212L238 134Z"></path>' +
          '<path class="mc-tri-right" d="M238 196h16v16"></path>' +
          bdg(418, 46, findHyp ? 'find' : 'known', 'mode:hyp', 'Find the hypotenuse') +
          bdg(136, 122, findHyp ? 'known' : 'find', 'mode:side', 'Find a shorter side') +
          '<text class="mc-tri-scale" x="552" y="340" text-anchor="end">not to scale</text></svg>';
      }
      var barF, barWhy;
      if (findHyp) {
        barF = valid
          ? 'c² = ' + H.fmt(x) + '² + ' + H.fmt(y) + '² = ' + nice(x * x) + ' + ' + nice(y * y) + ' = ' + nice(hypSq) + ', so c = √' + nice(hypSq) + ' ' + (exact ? '= <b>' + H.fmt(ans) + '</b>' : '≈ <b>' + nice(ans) + '</b>')
          : 'c² = a² + b²';
        barWhy = 'Add the squares when the hypotenuse is missing.';
      } else {
        barF = valid
          ? 'b² = ' + H.fmt(x) + '² − ' + H.fmt(y) + '² = ' + nice(x * x) + ' − ' + nice(y * y) + ' = ' + nice(missSq) + ', so b = √' + nice(missSq) + ' ' + (exact ? '= <b>' + H.fmt(ans) + '</b>' : '≈ <b>' + nice(ans) + '</b>')
          : 'b² = c² − a²';
        barWhy = 'Subtract the squares when a shorter side is missing.';
      }
      var tabs = '<div class="mc-rule-tabs" role="group" aria-label="Diagram view">' +
        '<button type="button" class="mc-rule-tab' + (sqView ? '' : ' is-on') + '" data-mc-tap data-set="view:tri" aria-pressed="' + !sqView + '">Triangle to scale</button>' +
        '<button type="button" class="mc-rule-tab' + (sqView ? ' is-on' : '') + '" data-mc-tap data-set="view:sq" aria-pressed="' + sqView + '">Why it works</button>' +
        '</div>';
      var hint = sqView
        ? '<p class="mc-tri-hint">Each square is a side times itself. ' + (findHyp ? 'The two green squares add to make the square on the hypotenuse.' : 'The missing square is the hypotenuse square minus the known one.') + ' Tap a <span class="mc-tri-q">?</span> to pick which side is missing.</p>'
        : '<p class="mc-tri-hint">The triangle redraws to match your numbers. Tap a <span class="mc-tri-q">?</span> to pick which side is missing. Green sides are the ones you know.</p>';
      return tabs + hint + svg +
        '<p class="mc-rule-line"><span class="mc-rule-f">' + barF + '</span><span class="mc-rule-why">' + barWhy + '</span></p>';
    }), labels: (function (v, H) {
      if (v.mode === 'hyp') return { x: 'First shorter side', y: 'Second shorter side' };
      return { x: 'Hypotenuse length', y: 'The shorter side you know' };
    }) };
MC_CONFIG["trigonometry-calculator"] = { name: "Trigonometry Calculator", fields: [{"id": "mode", "label": "What to find", "type": "select", "def": "side", "cls": "mc-ghost", "options": [["side", "A missing side"], ["angle", "A missing angle"]]}, {"id": "angle", "label": "The angle in degrees", "type": "number", "def": "30", "min": 0, "max": 90, "showIf": {"mode": ["side"]}}, {"id": "r1", "label": "The side you know is the", "type": "select", "def": "hyp", "cls": "mc-ghost", "options": [["opp", "Opposite (across from the angle)"], ["adj", "Adjacent (next to the angle)"], ["hyp", "Hypotenuse (longest side)"]]}, {"id": "val1", "label": "Its length", "type": "number", "def": "8", "gt": 0}, {"id": "r2", "label": "The side to find (or second side) is the", "type": "select", "def": "opp", "cls": "mc-ghost", "options": [["opp", "Opposite"], ["adj", "Adjacent"], ["hyp", "Hypotenuse"]]}, {"id": "val2", "label": "Second side length", "type": "number", "def": "4", "min": 0, "showIf": {"mode": ["angle"]}}], example: {"mode": "side", "angle": 30, "r1": "hyp", "val1": 8, "r2": "opp", "val2": 0}, run: (function (v, H) {
      var steps = [];
      if (v.r1 === v.r2) throw new Error('Pick two different sides, the known side and the one to find cannot both be the ' + v.r1 + '.');
      var names = { opp: 'opposite', adj: 'adjacent', hyp: 'hypotenuse' };
      var pair = [v.r1, v.r2].sort().join('-');
      var ratio, num, den;
      if (pair === 'hyp-opp') { ratio = 'sin'; num = 'opp'; den = 'hyp'; }
      else if (pair === 'adj-hyp') { ratio = 'cos'; num = 'adj'; den = 'hyp'; }
      else { ratio = 'tan'; num = 'opp'; den = 'adj'; }
      var tag = { sin: 'SOH', cos: 'CAH', tan: 'TOA' }[ratio];
      steps.push('The two sides in play are the ' + names[v.r1] + ' and the ' + names[v.r2] + ', so use ' + ratio + ' (' + tag + ')');
      if (v.mode === 'side') {
        if (v.angle <= 0 || v.angle >= 90) throw new Error('The angle must be between 0 and 90 degrees.');
        var f = Math[ratio === 'sin' ? 'sin' : ratio === 'cos' ? 'cos' : 'tan'](v.angle * Math.PI / 180);
        steps.push(ratio + '(' + H.fmt(v.angle) + '°) = ' + H.fmt(f));
        var ans;
        if (v.r2 === num) {
          ans = v.val1 * f;
          steps.push(names[num] + ' = ' + names[den] + ' × ' + ratio + '(' + H.fmt(v.angle) + '°): ' + H.fmt(v.val1) + ' × ' + H.fmt(f) + ' = ' + H.fmt(ans));
        } else {
          ans = v.val1 / f;
          steps.push(names[den] + ' = ' + names[num] + ' ÷ ' + ratio + '(' + H.fmt(v.angle) + '°): ' + H.fmt(v.val1) + ' ÷ ' + H.fmt(f) + ' = ' + H.fmt(ans));
        }
        return { answer: H.fmt(ans), steps: steps, note: 'Same unit as the side you typed in. Keep the calculator in degrees mode when you check this by hand.' };
      }
      if (v.val2 <= 0) throw new Error('Enter the second side length (bigger than 0) to find an angle.');
      var numVal = v.r1 === num ? v.val1 : v.val2;
      var denVal = v.r1 === num ? v.val2 : v.val1;
      var rv = numVal / denVal;
      if ((ratio === 'sin' || ratio === 'cos') && rv > 1) throw new Error('That would make the ' + names[num] + ' longer than the hypotenuse, which cannot happen in a right-angled triangle. Check which side is which.');
      steps.push(ratio + ' θ = ' + names[num] + ' ÷ ' + names[den] + ' = ' + H.fmt(numVal) + ' ÷ ' + H.fmt(denVal) + ' = ' + H.fmt(rv));
      var th = Math[ratio === 'sin' ? 'asin' : ratio === 'cos' ? 'acos' : 'atan'](rv) * 180 / Math.PI;
      steps.push('Undo it with the inverse: θ = ' + ratio + '⁻¹(' + H.fmt(rv) + ') = ' + H.fmt(th) + '°');
      return { answer: H.fmt(th) + '°', steps: steps, note: 'The inverse button is usually shift + ' + ratio + ' on a calculator.' };
    }), preview: (function (v, H) { var n = { opp: 'opposite', adj: 'adjacent', hyp: 'hypotenuse' }; if (v.mode === 'side') return 'Angle ' + v.angle + '°, ' + n[v.r1] + ' = ' + v.val1 + '. Find the ' + n[v.r2]; return n[v.r1] + ' = ' + v.val1 + ', ' + n[v.r2] + ' = ' + v.val2 + '. Angle = ?'; }), widget: (function (v, H) {
      var findAngle = v.mode === 'angle';
      var names = { opp: 'opposite', adj: 'adjacent', hyp: 'hypotenuse' };
      var caps = { opp: 'Opposite', adj: 'Adjacent', hyp: 'Hypotenuse' };
      var a1 = Number(v.val1), a2 = Number(v.val2), ang = Number(v.angle);
      var pairOk = v.r1 !== v.r2;
      var pair = [v.r1, v.r2].sort().join('-');
      var ratio = pair === 'hyp-opp' ? 'sin' : pair === 'adj-hyp' ? 'cos' : 'tan';
      var num = ratio === 'cos' ? 'adj' : 'opp';
      var den = ratio === 'tan' ? 'adj' : 'hyp';
      var D = Math.PI / 180;
      /* the one number everything hangs off: the angle, typed or computed */
      var th = null, ansV = null, rv = null;
      if (!findAngle) {
        if (pairOk && isFinite(ang) && ang > 0 && ang < 90 && isFinite(a1) && a1 > 0) {
          th = ang;
          var f = Math[ratio === 'sin' ? 'sin' : ratio === 'cos' ? 'cos' : 'tan'](ang * D);
          ansV = v.r2 === num ? a1 * f : a1 / f;
        }
      } else if (pairOk && isFinite(a1) && a1 > 0 && isFinite(a2) && a2 > 0) {
        var numVal = v.r1 === num ? a1 : a2;
        var denVal = v.r1 === num ? a2 : a1;
        rv = numVal / denVal;
        if (ratio === 'tan' || rv <= 1) {
          th = Math[ratio === 'sin' ? 'asin' : ratio === 'cos' ? 'acos' : 'atan'](rv) / D;
        }
      }
      var st = {}, txt = {}, sides = ['hyp', 'opp', 'adj'];
      for (var i = 0; i < sides.length; i++) {
        var s = sides[i];
        if (s === v.r1) { st[s] = 'known'; txt[s] = ' = ' + (isFinite(a1) ? H.fmt(a1) : v.val1); }
        else if (s === v.r2 && findAngle) { st[s] = 'known'; txt[s] = ' = ' + (isFinite(a2) ? H.fmt(a2) : v.val2); }
        else if (s === v.r2) { st[s] = 'find'; txt[s] = ' = ' + (ansV !== null ? H.fmt(ansV) : '?'); }
        else { st[s] = 'idle'; txt[s] = ''; }
      }
      function knowSet(s) {
        if (findAngle) return 'r1:' + (s === v.r2 ? v.r1 : s);
        return 'mode:side,r1:' + s + ',r2:' + (v.r2 === s ? v.r1 : v.r2);
      }
      function findSet(s) {
        return 'mode:side,r2:' + s + ',r1:' + (v.r1 === s ? v.r2 : v.r1);
      }
      /* draw at the real angle, clamped so the triangle stays readable */
      var deg = th !== null ? th : 30, capped = th === null;
      if (deg < 10) { deg = 10; capped = true; }
      if (deg > 70) { deg = 70; capped = true; }
      var t = Math.tan(deg * D);
      var W = Math.min(300, 175 / t), Hh = W * t;
      var ox = Math.max(96, Math.round((600 - W) / 2)), oy = 226;
      var ay = Math.round(oy - Hh), bx = Math.round(ox + W);
      function ln(x1, y1, x2, y2) {
        return '<line class="mc-tri-hit" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"></line>' +
          '<line class="mc-tri-line" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"></line>';
      }
      var el = H.triEl;
      var hypTxt = caps.hyp + txt.hyp, adjTxt = caps.adj + txt.adj;
      /* the adjacent chip shifts right when a steep angle shortens the base,
         so it never reaches back under the θ chip */
      var wAdj = 20 + adjTxt.length * 7.5;
      /* on a steep triangle the hypotenuse chip is clamped so its right edge
         stays on its own side of the vertical line, clear of the opposite's */
      var wHyp = 20 + hypTxt.length * 7.5;
      var hyp = el(Math.round(Math.min(ox + W * 0.45, bx + 8 - wHyp / 2)), Math.round(oy - Hh * 0.45 - 6), hypTxt, st.hyp, knowSet('hyp'), findSet('hyp'),
        'Mark the hypotenuse as a side you know', 'Find the hypotenuse', ln(ox, oy, bx, ay));
      /* a steep angle squeezes the triangle sideways and would land the
         opposite's chip on top of the hypotenuse's, so it steps off to the
         right of its line once the base gets narrow */
      var oppTxt = caps.opp + txt.opp;
      var oppCx = W < 200 ? Math.round(bx + (20 + oppTxt.length * 7.5) / 2 + 12) : bx;
      var opp = el(oppCx, Math.round((ay + oy) / 2), oppTxt, st.opp, knowSet('opp'), findSet('opp'),
        'Mark the opposite as a side you know', 'Find the opposite', ln(bx, oy, bx, ay));
      var adj = el(Math.round(Math.max(ox + W / 2, ox + wAdj / 2 + 6)), oy + 21, adjTxt, st.adj, knowSet('adj'), findSet('adj'),
        'Mark the adjacent as a side you know', 'Find the adjacent', ln(ox, oy, bx, oy));
      var thTxt = 'θ = ' + (findAngle ? (th !== null ? H.fmt(th) + '°' : '?') : (isFinite(ang) ? H.fmt(ang) + '°' : '?'));
      var theta = el(Math.round(ox - (20 + thTxt.length * 7.5) / 2 - 6), oy - 15, thTxt,
        findAngle ? 'find' : 'known', 'mode:side', 'mode:angle',
        'Switch to finding a side, with the angle known', 'Find the angle', '');
      var arcR = 46;
      var arcX = ox + arcR, arcY = oy;
      var arcEX = ox + arcR * Math.cos(deg * D), arcEY = oy - arcR * Math.sin(deg * D);
      var svg = '<svg class="mc-tri" viewBox="0 0 600 278" aria-hidden="false" role="group" aria-label="Right angled triangle drawn at your angle, tap the sides and angle to set the question">' +
        '<path class="mc-tri-face" d="M' + ox + ' ' + oy + 'L' + bx + ' ' + oy + 'L' + bx + ' ' + ay + 'Z"></path>' +
        '<path class="mc-tri-right" d="M' + (bx - 16) + ' ' + oy + 'v-16h16"></path>' +
        '<path class="mc-tri-arc is-' + (findAngle ? 'find' : 'known') + '" d="M' + arcX + ' ' + arcY + 'A' + arcR + ' ' + arcR + ' 0 0 0 ' + arcEX.toFixed(1) + ' ' + arcEY.toFixed(1) + '"></path>' +
        '<text class="mc-tri-scale" x="592" y="274" text-anchor="end">' + (capped ? 'not to scale' : 'drawn to scale') + '</text>' +
        hyp + opp + adj + theta + '</svg>';
      /* the coach row: the two sides in play light their card */
      function card(tag2, f2, on) {
        return '<div class="mc-soh-card ' + (on ? 'is-on' : 'is-dim') + '">' +
          '<span class="mc-soh-tag">' + tag2 + '</span><div class="mc-soh-f">' + f2 + '</div>' +
          (on ? '<span class="mc-soh-pick">✓ your two sides</span>' : '') + '</div>';
      }
      var cards = '<div class="mc-soh-row" aria-label="Which ratio">' +
        card('TOA', 'tan θ = opp ÷ adj', ratio === 'tan') +
        card('SOH', 'sin θ = opp ÷ hyp', ratio === 'sin') +
        card('CAH', 'cos θ = adj ÷ hyp', ratio === 'cos') + '</div>';
      var barF, barWhy = caps[num] + ' and ' + names[den] + ' in play, so ' + ratio + ' (' + { sin: 'SOH', cos: 'CAH', tan: 'TOA' }[ratio] + ').';
      if (!findAngle) {
        if (th !== null) {
          var f2 = Math[ratio === 'sin' ? 'sin' : ratio === 'cos' ? 'cos' : 'tan'](ang * D);
          barF = ratio + '(' + H.fmt(ang) + '°) = ' + H.fmt(f2) + ', so ' + names[v.r2] + ' = ' + H.fmt(a1) + (v.r2 === num ? ' × ' : ' ÷ ') + H.fmt(f2) + ' = <b>' + H.fmt(ansV) + '</b>';
        } else {
          barF = ratio + ' θ = ' + names[num] + ' ÷ ' + names[den];
        }
      } else if (th !== null) {
        barF = ratio + ' θ = ' + H.fmt(rv) + ', so θ = ' + ratio + '⁻¹(' + H.fmt(rv) + ') = <b>' + H.fmt(th) + '°</b>';
      } else {
        barF = ratio + ' θ = ' + names[num] + ' ÷ ' + names[den] + ', then θ = ' + ratio + '⁻¹ of that';
      }
      return '<p class="mc-tri-hint">Tap a <span class="mc-tri-q">?</span> to pick what to find. Tap a side to say you know it. The two sides in play choose the ratio for you.</p>' +
        svg + cards +
        '<p class="mc-rule-line"><span class="mc-rule-f">' + barF + '</span><span class="mc-rule-why">' + barWhy + '</span></p>';
    }), labels: (function (v, H) {
      var n = { opp: 'Opposite', adj: 'Adjacent', hyp: 'Hypotenuse' };
      var L = { val1: n[v.r1] + ' length' };
      if (v.mode === 'angle') L.val2 = n[v.r2] + ' length';
      return L;
    }) };
MC_CONFIG["quadratic-equation-calculator"] = { name: "Quadratic Equation Calculator", fields: [{"id": "a", "group": "Q", "groupLabel": "The equation", "label": "a (the number with x\u00b2)", "type": "number", "def": "1"}, {"id": "b", "group": "Q", "label": "b (the number with x)", "type": "number", "def": "-5"}, {"id": "c", "group": "Q", "label": "c (the number on its own)", "type": "number", "def": "6"}], example: {"a": 1, "b": -5, "c": 6}, run: (function (v, H) {
      if (v.a === 0) throw new Error('a cannot be 0, with no x² term the equation is linear, not quadratic.');
      var steps = [];
      steps.push('Write down the coefficients: a = ' + H.fmt(v.a) + ', b = ' + H.fmt(v.b) + ', c = ' + H.fmt(v.c));
      var D = v.b * v.b - 4 * v.a * v.c;
      var fourac = 4 * v.a * v.c;
      steps.push('Find the discriminant: b² − 4ac = ' + H.fmt(v.b * v.b) + ' − ' + (fourac < 0 ? '(' + H.fmt(fourac) + ')' : H.fmt(fourac)) + ' = ' + H.fmt(D));
      if (D < 0) {
        steps.push('The discriminant is negative, and no number squares to a negative');
        steps.push('So the equation has no real solutions');
        return { answer: 'No real solutions', steps: steps, note: 'A negative discriminant means the graph never crosses the x axis.' };
      }
      var twoA = 2 * v.a;
      if (D === 0) {
        var x0 = -v.b / twoA;
        steps.push('The discriminant is exactly 0, so there is one repeated solution');
        steps.push('x = −b ÷ 2a = ' + H.fmt(-v.b) + ' ÷ ' + H.fmt(twoA) + ' = ' + H.fmt(x0));
        return { answer: 'x = ' + H.fmt(x0) + ' (repeated)', steps: steps, note: 'The graph just touches the x axis at this single point.' };
      }
      var sqrtD = Math.sqrt(D);
      var perfect = Math.abs(Math.round(sqrtD) * Math.round(sqrtD) - D) < 1e-9;
      steps.push('The discriminant is positive, so there are two solutions');
      steps.push('Use the formula: x = (−b ± √D) ÷ 2a = (' + H.fmt(-v.b) + ' ± √' + H.fmt(D) + ') ÷ ' + H.fmt(twoA));
      var x1 = (-v.b + sqrtD) / twoA;
      var x2 = (-v.b - sqrtD) / twoA;
      if (perfect) {
        steps.push('√' + H.fmt(D) + ' = ' + H.fmt(Math.round(sqrtD)) + ', so x = ' + H.fmt(x1) + ' or x = ' + H.fmt(x2));
        return { answer: 'x = ' + H.fmt(x1) + ' or x = ' + H.fmt(x2), steps: steps };
      }
      steps.push('√' + H.fmt(D) + ' is not whole, so as decimals: x = ' + H.fmt(x1) + ' or x = ' + H.fmt(x2));
      return {
        answer: 'x = ' + H.fmt(x1) + ' or x = ' + H.fmt(x2), steps: steps,
        note: 'Exactly: x = (' + H.fmt(-v.b) + ' ± √' + H.fmt(D) + ') ÷ ' + H.fmt(twoA) + '. Leave it in this form if the question says "exact".'
      };
    }), preview: (function (v, H) { function t(k, s) { if (k === '?' || k === '') return ' + ?' + s; var n = Number(k); if (n === 0) return ''; var mag = Math.abs(n) === 1 && s ? '' : String(Math.abs(n)); return (n < 0 ? ' − ' : ' + ') + mag + s; } var first = (v.a === '?' ? '?' : (Number(v.a) === 1 ? '' : Number(v.a) === -1 ? '−' : v.a)) + 'x²'; return first + t(v.b, 'x') + t(v.c, '') + ' = 0'; }) };
MC_CONFIG["simultaneous-equations-calculator"] = { name: "Simultaneous Equations Calculator", fields: [{"id": "a1", "group": "E1", "groupLabel": "Equation 1", "label": "Equation 1: number with x", "type": "number", "def": "2"}, {"id": "b1", "group": "E1", "label": "Equation 1: number with y", "type": "number", "def": "3"}, {"id": "c1", "group": "E1", "label": "Equation 1: right hand side", "type": "number", "def": "12"}, {"id": "a2", "group": "E2", "groupLabel": "Equation 2", "label": "Equation 2: number with x", "type": "number", "def": "1"}, {"id": "b2", "group": "E2", "label": "Equation 2: number with y", "type": "number", "def": "-1"}, {"id": "c2", "group": "E2", "label": "Equation 2: right hand side", "type": "number", "def": "1"}], example: {"a1": 2, "b1": 3, "c1": 12, "a2": 1, "b2": -1, "c2": 1}, run: (function (v, H) {
      function term(coef, letter, first) {
        if (coef === 0) return '';
        var mag = Math.abs(coef);
        var body = (mag === 1 ? '' : H.fmt(mag)) + letter;
        if (first) return (coef < 0 ? '−' : '') + body;
        return (coef < 0 ? ' − ' : ' + ') + body;
      }
      function eqStr(a, b, c) {
        var left = term(a, 'x', true);
        left += term(b, 'y', left === '');
        return left + ' = ' + H.fmt(c);
      }
      if ((v.a1 === 0 && v.b1 === 0) || (v.a2 === 0 && v.b2 === 0)) throw new Error('Each equation needs an x term or a y term.');
      if (v.a1 === 0 && v.a2 === 0) throw new Error('Neither equation has an x term, solve each for y on its own instead.');
      if (v.b1 === 0 && v.b2 === 0) throw new Error('Neither equation has a y term, solve each for x on its own instead.');
      var steps = ['Label the equations: (1) ' + eqStr(v.a1, v.b1, v.c1) + ' and (2) ' + eqStr(v.a2, v.b2, v.c2)];
      var yc, rhs, subA, subB, subC, subName;
      if (v.a1 === 0) {
        yc = v.b1; rhs = v.c1; subA = v.a2; subB = v.b2; subC = v.c2; subName = '(2)';
        steps.push('Equation (1) has no x term, so it already gives y on its own: ' + eqStr(0, v.b1, v.c1));
      } else if (v.a2 === 0) {
        yc = v.b2; rhs = v.c2; subA = v.a1; subB = v.b1; subC = v.c1; subName = '(1)';
        steps.push('Equation (2) has no x term, so it already gives y on its own: ' + eqStr(0, v.b2, v.c2));
      } else {
        if (v.a2 !== 1) steps.push('Multiply (1) by ' + H.fmt(v.a2) + ': ' + eqStr(v.a1 * v.a2, v.b1 * v.a2, v.c1 * v.a2));
        if (v.a1 !== 1) steps.push('Multiply (2) by ' + H.fmt(v.a1) + ': ' + eqStr(v.a2 * v.a1, v.b2 * v.a1, v.c2 * v.a1));
        yc = v.a2 * v.b1 - v.a1 * v.b2;
        rhs = v.a2 * v.c1 - v.a1 * v.c2;
        if (yc === 0) {
          if (rhs === 0) {
            steps.push('Subtracting removes the x terms AND the y terms, leaving 0 = 0');
            steps.push('Both equations are the same line, so every point on it works, there are infinitely many solutions');
            return { answer: 'Infinitely many solutions (the same line)', steps: steps };
          }
          steps.push('Subtracting removes the x terms AND the y terms, leaving 0 = ' + H.fmt(rhs) + ', which is impossible');
          steps.push('The lines are parallel, so there is no solution');
          return { answer: 'No solution (parallel lines)', steps: steps };
        }
        steps.push('Subtract, and the x terms cancel: ' + eqStr(0, yc, rhs));
        subA = v.a1; subB = v.b1; subC = v.c1; subName = '(1)';
      }
      if (yc === 0) throw new Error('That pair does not pin y down, check the numbers.');
      var y = rhs / yc;
      steps.push('Solve for y: y = ' + H.fmt(rhs) + ' ÷ ' + H.fmt(yc) + ' = ' + H.fmt(y));
      var x = (subC - subB * y) / subA;
      steps.push('Substitute y = ' + H.fmt(y) + ' into ' + subName + ': ' + H.fmt(subA) + 'x = ' + H.fmt(subC) + ' − ' + (subB * y < 0 ? '(' + H.fmt(subB * y) + ')' : H.fmt(subB * y)) + ' = ' + H.fmt(subC - subB * y));
      steps.push('So x = ' + H.fmt(x) + ' and y = ' + H.fmt(y));
      return {
        answer: 'x = ' + H.fmt(x) + ', y = ' + H.fmt(y), steps: steps,
        note: 'Check by substituting both values into the equation you did NOT use, both sides should match.'
      };
    }), preview: (function (v, H) { function eq(a, b, c) { function pt(k, s, first) { if (k === '?') return (first ? '' : ' + ') + '?' + s; var n = Number(k); if (n === 0) return ''; var mag = Math.abs(n) === 1 ? '' : String(Math.abs(n)); if (first) return (n < 0 ? '−' : '') + mag + s; return (n < 0 ? ' − ' : ' + ') + mag + s; } var L = pt(a, 'x', true); L += pt(b, 'y', L === ''); return (L || '0') + ' = ' + c; } return '(1)  ' + eq(v.a1, v.b1, v.c1) + '      (2)  ' + eq(v.a2, v.b2, v.c2); }) };
MC_CONFIG["straight-line-graph-calculator"] = { name: "Straight Line Graph Calculator", fields: [{"id": "x1", "group": "P1", "groupLabel": "First point", "label": "First point: x", "type": "number", "def": "1"}, {"id": "y1", "group": "P1", "label": "First point: y", "type": "number", "def": "3"}, {"id": "x2", "group": "P2", "groupLabel": "Second point", "label": "Second point: x", "type": "number", "def": "5"}, {"id": "y2", "group": "P2", "label": "Second point: y", "type": "number", "def": "7"}], example: {"x1": 1, "y1": 3, "x2": 5, "y2": 7}, run: (function (v, H) {
      if (v.x1 === v.x2 && v.y1 === v.y2) throw new Error('Those are the same point twice, a line needs two different points.');
      function wrap(n) { return n < 0 ? '(' + H.fmt(n) + ')' : H.fmt(n); }
      var steps = [];
      var dx = v.x2 - v.x1, dy = v.y2 - v.y1;
      var mx = (v.x1 + v.x2) / 2, my = (v.y1 + v.y2) / 2;
      var lenSq = dx * dx + dy * dy;
      var lenStr;
      var r = Math.round(Math.sqrt(lenSq));
      if (Math.abs(r * r - lenSq) < 1e-9) {
        lenStr = H.fmt(r);
      } else if (Number.isInteger(lenSq)) {
        var s = Math.floor(Math.sqrt(lenSq)), best = 1;
        for (var k = s; k >= 2; k--) { if (lenSq % (k * k) === 0) { best = k; break; } }
        lenStr = best > 1
          ? H.fmt(best) + '√' + H.fmt(lenSq / (best * best)) + ' (≈ ' + H.fmt(Math.sqrt(lenSq)) + ')'
          : '√' + H.fmt(lenSq) + ' (≈ ' + H.fmt(Math.sqrt(lenSq)) + ')';
      } else {
        lenStr = H.fmt(Math.sqrt(lenSq));
      }
      if (dx === 0) {
        steps.push('Both x values are ' + H.fmt(v.x1) + ', so the line is vertical: x = ' + H.fmt(v.x1));
        steps.push('A vertical line has no gradient in y = mx + c form');
        steps.push('Midpoint: average each coordinate: (' + H.fmt(mx) + ', ' + H.fmt(my) + ')');
        steps.push('Length: the points sit straight above each other, so it is the y gap: ' + H.fmt(Math.abs(dy)));
        return { answer: 'Vertical line x = ' + H.fmt(v.x1) + ', midpoint (' + H.fmt(mx) + ', ' + H.fmt(my) + '), length ' + H.fmt(Math.abs(dy)), steps: steps };
      }
      var m = dy / dx;
      var c = v.y1 - m * v.x1;
      steps.push('Gradient: m = (y₂ − y₁) ÷ (x₂ − x₁) = (' + wrap(v.y2) + ' − ' + wrap(v.y1) + ') ÷ (' + wrap(v.x2) + ' − ' + wrap(v.x1) + ') = ' + H.fmt(dy) + ' ÷ ' + H.fmt(dx) + ' = ' + H.fmt(m));
      steps.push('Midpoint: average each coordinate: ((' + wrap(v.x1) + ' + ' + wrap(v.x2) + ') ÷ 2, (' + wrap(v.y1) + ' + ' + wrap(v.y2) + ') ÷ 2) = (' + H.fmt(mx) + ', ' + H.fmt(my) + ')');
      steps.push('Length: Pythagoras on the gaps: √(' + wrap(dx) + '² + ' + wrap(dy) + '²) = √' + H.fmt(lenSq) + ' = ' + lenStr);
      steps.push('Find c with y = mx + c at (' + H.fmt(v.x1) + ', ' + H.fmt(v.y1) + '): ' + H.fmt(v.y1) + ' = ' + H.fmt(m) + ' × ' + wrap(v.x1) + ' + c, so c = ' + H.fmt(c));
      var mTerm = m === 1 ? 'x' : (m === -1 ? '−x' : H.fmt(m) + 'x');
      var eq = m === 0 ? 'y = ' + H.fmt(c) : 'y = ' + mTerm + (c === 0 ? '' : (c > 0 ? ' + ' + H.fmt(c) : ' − ' + H.fmt(-c)));
      steps.push('So the equation is ' + eq);
      return {
        answer: 'Gradient ' + H.fmt(m) + ', midpoint (' + H.fmt(mx) + ', ' + H.fmt(my) + '), length ' + lenStr + ', equation ' + eq,
        steps: steps
      };
    }), preview: (function (v, H) { return 'From (' + v.x1 + ', ' + v.y1 + ') to (' + v.x2 + ', ' + v.y2 + ')'; }) };
MC_CONFIG["mean-median-mode-calculator"] = { name: "Mean Median Mode Calculator", fields: [{"id": "values", "label": "Your numbers", "type": "text", "def": "3, 8, 5, 8, 6", "hint": "Separate with commas or spaces. Between 2 and 50 numbers."}], example: {"values": "3, 8, 5, 8, 6"}, run: (function (v, H) {
      var raw = String(v.values).trim().split(/[\s,]+/).filter(function (t) { return t !== ''; });
      var nums = [];
      for (var i = 0; i < raw.length; i++) {
        var n = Number(raw[i]);
        if (!isFinite(n)) throw new Error('"' + raw[i] + '" is not a number, use digits only, separated by commas.');
        nums.push(n);
      }
      if (nums.length < 2) throw new Error('Enter at least two numbers.');
      if (nums.length > 50) throw new Error('Use 50 numbers or fewer.');
      var sorted = nums.slice().sort(function (a, b) { return a - b; });
      var steps = ['Put the ' + nums.length + ' numbers in order: ' + sorted.map(H.fmt).join(', ')];
      var sum = 0;
      for (var j = 0; j < nums.length; j++) sum += nums[j];
      var mean = sum / nums.length;
      steps.push('Mean: add them up, divide by how many: ' + H.fmt(sum) + ' ÷ ' + nums.length + ' = ' + H.fmt(mean));
      var med;
      var half = Math.floor(sorted.length / 2);
      if (sorted.length % 2 === 1) {
        med = sorted[half];
        steps.push('Median: the middle value of the ordered list is ' + H.fmt(med));
      } else {
        med = (sorted[half - 1] + sorted[half]) / 2;
        steps.push('Median: average the middle two: (' + H.fmt(sorted[half - 1]) + ' + ' + H.fmt(sorted[half]) + ') ÷ 2 = ' + H.fmt(med));
      }
      var freq = {}, maxF = 0;
      for (var k = 0; k < sorted.length; k++) {
        freq[sorted[k]] = (freq[sorted[k]] || 0) + 1;
        if (freq[sorted[k]] > maxF) maxF = freq[sorted[k]];
      }
      var modeStr;
      if (maxF === 1) {
        modeStr = 'none';
        steps.push('Mode: every value appears exactly once, so there is no mode');
      } else {
        var modes = [];
        var seen = {};
        for (var m = 0; m < sorted.length; m++) {
          if (freq[sorted[m]] === maxF && !seen[sorted[m]]) { modes.push(H.fmt(sorted[m])); seen[sorted[m]] = 1; }
        }
        modeStr = modes.join(' and ');
        steps.push('Mode: ' + modeStr + ' ' + H.plural(modes.length, 'appears', 'each appear') + ' ' + maxF + ' times, more than anything else');
      }
      var range = sorted[sorted.length - 1] - sorted[0];
      steps.push('Range: biggest − smallest: ' + H.fmt(sorted[sorted.length - 1]) + ' − ' + H.fmt(sorted[0]) + ' = ' + H.fmt(range));
      return {
        answer: 'Mean ' + H.fmt(mean) + ', median ' + H.fmt(med) + ', mode ' + modeStr + ', range ' + H.fmt(range),
        steps: steps,
        note: 'The range measures spread, not average, a big range means the data is widely scattered.'
      };
    }), preview: (function (v, H) { return 'The numbers: ' + v.values; }) };
MC_CONFIG["speed-distance-time-calculator"] = { name: "Speed Distance Time Calculator", fields: [{"id": "formula", "label": "Formula", "type": "select", "def": "sdt", "cls": "mc-ghost", "options": [["sdt", "Speed, distance, time"], ["dmv", "Density, mass, volume"], ["fpa", "Pressure, force, area"]]}, {"id": "find", "label": "Find which part", "type": "select", "def": "left", "cls": "mc-ghost", "options": [["top", "The top of the triangle"], ["left", "Bottom left"], ["right", "Bottom right"]]}, {"id": "top", "label": "Distance, mass or force", "type": "number", "def": "120", "min": 0, "showIf": {"find": ["left", "right"]}}, {"id": "left", "label": "Speed / density / pressure", "type": "number", "def": "40", "min": 0, "showIf": {"find": ["top", "right"]}}, {"id": "right", "label": "Time / volume / area", "type": "number", "def": "3", "min": 0, "showIf": {"find": ["top", "left"]}}], example: {"formula": "sdt", "find": "left", "top": 120, "left": 40, "right": 3}, run: (function (v, H) {
      var N = {
        sdt: { top: 'distance', left: 'speed', right: 'time' },
        dmv: { top: 'mass', left: 'density', right: 'volume' },
        fpa: { top: 'force', left: 'pressure', right: 'area' }
      }[v.formula];
      var target;
      if (v.find === 'top' || v.find === 'left' || v.find === 'right') {
        target = v.find;
        if (target === 'left' && v.right === 0) throw new Error('The ' + N.right + ' cannot be 0 here, there would be nothing to divide by.');
        if (target === 'right' && v.left === 0) throw new Error('The ' + N.left + ' cannot be 0 here, there would be nothing to divide by.');
      } else {
        /* legacy zero-target convention, kept for saved links and QA cases */
        var zeros = [];
        if (v.top === 0) zeros.push('top');
        if (v.left === 0) zeros.push('left');
        if (v.right === 0) zeros.push('right');
        if (zeros.length !== 1) throw new Error('Leave exactly one box at 0, the one you want to find. Fill in the other two.');
        target = zeros[0];
      }
      function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
      var steps = ['The triangle: ' + N.top + ' on top, ' + N.left + ' and ' + N.right + ' side by side underneath, so ' + N.top + ' = ' + N.left + ' × ' + N.right];
      var ans;
      if (target === 'top') {
        ans = v.left * v.right;
        steps.push('Cover ' + N.top + ': what is left is ' + N.left + ' × ' + N.right);
        steps.push(N.top + ' = ' + H.fmt(v.left) + ' × ' + H.fmt(v.right) + ' = ' + H.fmt(ans));
      } else if (target === 'left') {
        ans = v.top / v.right;
        steps.push('Cover ' + N.left + ': what is left is ' + N.top + ' over ' + N.right + ', a division');
        steps.push(N.left + ' = ' + N.top + ' ÷ ' + N.right + ' = ' + H.fmt(v.top) + ' ÷ ' + H.fmt(v.right) + ' = ' + H.fmt(ans));
      } else {
        ans = v.top / v.left;
        steps.push('Cover ' + N.right + ': what is left is ' + N.top + ' over ' + N.left + ', a division');
        steps.push(N.right + ' = ' + N.top + ' ÷ ' + N.left + ' = ' + H.fmt(v.top) + ' ÷ ' + H.fmt(v.left) + ' = ' + H.fmt(ans));
      }
      return {
        answer: cap(N[target]) + ' = ' + H.fmt(ans),
        steps: steps,
        note: 'Keep the units consistent: km with hours gives km/h, metres with seconds gives m/s, grams with cm³ gives g/cm³.'
      };
    }), preview: (function (v, H) {
      var N = { sdt: ['distance', 'speed', 'time'], dmv: ['mass', 'density', 'volume'], fpa: ['force', 'pressure', 'area'] }[v.formula];
      var names = { top: N[0], left: N[1], right: N[2] };
      var f = names[v.find] ? v.find : 'left';
      var known = [];
      if (f !== 'top') known.push(names.top + ' ' + v.top);
      if (f !== 'left') known.push(names.left + ' ' + v.left);
      if (f !== 'right') known.push(names.right + ' ' + v.right);
      return names[f] + ' = ?, from ' + known[0] + ' and ' + known[1];
    }), widget: (function (v, H) {
      var TABS = [['sdt', 'Speed, distance, time'], ['dmv', 'Density, mass, volume'], ['fpa', 'Pressure, force, area']];
      var html = '<div class="mc-rule-tabs">';
      var i;
      for (i = 0; i < TABS.length; i++) {
        html += '<button type="button" class="mc-rule-tab' + (v.formula === TABS[i][0] ? ' is-on' : '') + '" data-mc-tap data-set="formula:' + TABS[i][0] + '">' + TABS[i][1] + '</button>';
      }
      html += '</div>';
      var N = { sdt: ['Distance', 'Speed', 'Time'], dmv: ['Mass', 'Density', 'Volume'], fpa: ['Force', 'Pressure', 'Area'] }[v.formula];
      if (!N) return html;
      var f = { top: 1, left: 1, right: 1 }[v.find] ? v.find : 'left';
      function cell(key, cx, cy, word, val) {
        var isFind = f === key;
        var chip = isFind
          ? '<text x="' + cx + '" y="' + (cy + 22) + '" text-anchor="middle" class="mc-dst-q">?</text>'
          : '<text x="' + cx + '" y="' + (cy + 22) + '" text-anchor="middle" class="mc-dst-val">' + (val === '?' ? '' : val) + '</text>';
        return '<g class="mc-dst-cell' + (isFind ? ' is-find' : ' is-known') + '" data-mc-tap data-set="find:' + key + '" role="button" tabindex="0" aria-label="Find ' + word + '">'
          + '<text x="' + cx + '" y="' + cy + '" text-anchor="middle" class="mc-dst-word">' + word + '</text>' + chip + '</g>';
      }
      var tri = '<svg class="mc-dst" viewBox="0 0 320 210" aria-hidden="false">'
        + '<path d="M 160 14 L 26 196 L 294 196 Z" class="mc-dst-face"/>'
        + '<line x1="93" y1="105" x2="227" y2="105" class="mc-dst-div"/>'
        + '<line x1="160" y1="105" x2="160" y2="196" class="mc-dst-div"/>'
        + cell('top', 160, 66, N[0], v.top)
        + cell('left', 118, 140, N[1], v.left)
        + cell('right', 202, 140, N[2], v.right)
        + '</svg>';
      var FORM = {
        top: N[0] + ' = ' + N[1] + ' × ' + N[2],
        left: N[1] + ' = ' + N[0] + ' ÷ ' + N[2],
        right: N[2] + ' = ' + N[0] + ' ÷ ' + N[1]
      }[f];
      var line = '<p class="mc-rule-line"><span class="mc-rule-f">' + FORM + '</span>'
        + '<span class="mc-rule-why">Tap the one you want: covering it leaves the formula.</span></p>';
      return html + '<div class="mc-dst-wrap">' + tri + '</div>' + line;
    }), labels: (function (v, H) {
      var L = {
        sdt: { top: 'Distance', left: 'Speed', right: 'Time (hours)' },
        dmv: { top: 'Mass (g)', left: 'Density (g/cm³)', right: 'Volume (cm³)' },
        fpa: { top: 'Force (N)', left: 'Pressure (N/m²)', right: 'Area (m²)' }
      }[v.formula] || { top: 'Top', left: 'Bottom left', right: 'Bottom right' };
      return { top: L.top, left: L.left, right: L.right };
    }) };
MC_CONFIG["probability-calculator"] = { name: "Probability Calculator", fields: [{"id": "mode", "label": "What to work out", "type": "select", "def": "single", "options": [["single", "One event"], ["and", "Two events: BOTH happen (AND)"], ["or", "Two events: EITHER one (OR)"], ["tree", "Two events: the full tree"]]}, {"id": "f1", "group": "A", "groupLabel": "Event 1", "slot": "num", "label": "Event 1: ways it can happen", "type": "number", "def": "2", "min": 0, "int": true}, {"id": "n1", "group": "A", "slot": "den", "label": "Event 1: total equally likely outcomes", "type": "number", "def": "6", "gt": 0, "int": true}, {"id": "f2", "group": "B", "groupLabel": "Event 2", "slot": "num", "label": "Event 2: ways it can happen", "type": "number", "def": "1", "min": 0, "int": true, "showIf": {"mode": ["and", "or", "tree"]}}, {"id": "n2", "group": "B", "slot": "den", "label": "Event 2: total outcomes", "type": "number", "def": "2", "gt": 0, "int": true, "showIf": {"mode": ["and", "or", "tree"]}}], example: {"mode": "single", "f1": 2, "n1": 6, "f2": 1, "n2": 2}, run: (function (v, H) {
      if (v.f1 > v.n1) throw new Error('Event 1 cannot have more ways to happen than total outcomes.');
      if (v.mode !== 'single' && v.f2 > v.n2) throw new Error('Event 2 cannot have more ways to happen than total outcomes.');
      function frac(n, d) {
        var g = H.gcd(n, d) || 1;
        return [n / g, d / g];
      }
      function fs(p) { return p[1] === 1 ? H.fmt(p[0]) : H.frTok(p[0], p[1]); }
      function triple(p) {
        var dec = p[0] / p[1];
        return fs(p) + ' = ' + H.fmt(dec) + ' = ' + H.fmt(dec * 100) + '%';
      }
      var steps = [];
      if (v.mode === 'single') {
        var p = frac(v.f1, v.n1);
        steps.push('Probability = ways it can happen ÷ total outcomes: ' + H.frTok(v.f1, v.n1));
        if (p[0] !== v.f1) steps.push('Simplify: ' + H.frTok(v.f1, v.n1) + ' = ' + fs(p));
        steps.push('So P = ' + triple(p));
        return { answer: triple(p), steps: steps, note: 'Probabilities always sit between 0 (impossible) and 1 (certain).' };
      }
      if (v.mode === 'and') {
        steps.push('BOTH means AND, and AND means MULTIPLY the probabilities');
        var pa = frac(v.f1 * v.f2, v.n1 * v.n2);
        steps.push('P(A) × P(B) = ' + H.frTok(v.f1, v.n1) + ' × ' + H.frTok(v.f2, v.n2) + ' = ' + H.frTok(v.f1 * v.f2, v.n1 * v.n2));
        if (pa[0] !== v.f1 * v.f2) steps.push('Simplify: ' + H.frTok(v.f1 * v.f2, v.n1 * v.n2) + ' = ' + fs(pa));
        steps.push('So P(both) = ' + triple(pa));
        return { answer: triple(pa), steps: steps, note: 'Multiplying only works when the events are independent, one happening does not change the other.' };
      }
      if (v.mode === 'or') {
        var L = H.lcm(v.n1, v.n2);
        var N = v.f1 * (L / v.n1) + v.f2 * (L / v.n2);
        if (N > L) throw new Error('Those probabilities add to more than 1, so the events CAN happen together, the simple OR rule only works when they cannot.');
        steps.push('EITHER (when they cannot both happen) means OR, and OR means ADD');
        steps.push('Common denominator ' + H.fmt(L) + ': ' + H.frTok(v.f1, v.n1) + ' + ' + H.frTok(v.f2, v.n2) + ' = ' + H.frTok(v.f1 * (L / v.n1), H.fmt(L)) + ' + ' + H.frTok(v.f2 * (L / v.n2), H.fmt(L)) + ' = ' + H.frTok(N, H.fmt(L)));
        var po = frac(N, L);
        if (po[0] !== N) steps.push('Simplify: ' + H.frTok(N, H.fmt(L)) + ' = ' + fs(po));
        steps.push('So P(either) = ' + triple(po));
        return { answer: triple(po), steps: steps };
      }
      /* tree */
      var D = v.n1 * v.n2;
      var both = frac(v.f1 * v.f2, D);
      var only1 = v.f1 * (v.n2 - v.f2);
      var only2 = (v.n1 - v.f1) * v.f2;
      var exactly = frac(only1 + only2, D);
      var neither = frac((v.n1 - v.f1) * (v.n2 - v.f2), D);
      steps.push('First find the NOT branches: P(not A) = ' + H.frTok(v.n1 - v.f1, v.n1) + ' and P(not B) = ' + H.frTok(v.n2 - v.f2, v.n2));
      steps.push('Multiply along the branches, both: ' + H.frTok(v.f1, v.n1) + ' × ' + H.frTok(v.f2, v.n2) + ' = ' + fs(both));
      steps.push('Exactly one (A only + B only): ' + H.frTok(only1, D) + ' + ' + H.frTok(only2, D) + ' = ' + fs(exactly));
      steps.push('Neither: ' + H.frTok(v.n1 - v.f1, v.n1) + ' × ' + H.frTok(v.n2 - v.f2, v.n2) + ' = ' + fs(neither));
      steps.push('So both = ' + fs(both) + ', exactly one = ' + fs(exactly) + ', neither = ' + fs(neither));
      return {
        answer: 'Both ' + fs(both) + ', exactly one ' + fs(exactly) + ', neither ' + fs(neither),
        steps: steps,
        note: 'Check: the three outcomes cover everything, so their probabilities add up to 1.'
      };
    }), preview: (function (v, H) { if (v.mode === 'single') return 'P = ' + v.f1 + ' out of ' + v.n1; if (v.mode === 'and') return 'P(A) = ' + H.frTok(v.f1, v.n1) + ' AND P(B) = ' + H.frTok(v.f2, v.n2); if (v.mode === 'or') return 'P(A) = ' + H.frTok(v.f1, v.n1) + ' OR P(B) = ' + H.frTok(v.f2, v.n2); return 'Tree for P(A) = ' + H.frTok(v.f1, v.n1) + ' and P(B) = ' + H.frTok(v.f2, v.n2); }) };